(function() {
	'use strict';

	// --- 設定 ---
	var iframeBaseUrl = null;
	var stripePublishableKey = null;
	var IFRAME_PATH = '/embed/spixn-wari';
	// SpinCard_C (ログイン後・未適用) 用の hidden iframe ルート。
	// BalanceFetcher が OTC 交換 + orders 取得 + 合計算出を行い postMessage で残高を返す。
	var BALANCE_IFRAME_PATH = '/embed/spixn-wari/balance';
	var DEBUG_MODE = false;
	// カート小計の即割適用閾値（JPY）。S1-2539時点では固定値。
	var SPIXN_MIN_SUBTOTAL = 10000;
	// 予約販売（PRE-ORDER）商品のタグ名。カートにこのタグの商品があれば即割 UI を
	// 非表示にする（S1-2657）。店舗でタグ名が異なれば調整する。
	var SPIXN_PREORDER_TAG = 'PRE-ORDER';
	// スピン即割発行コードの prefix。`cart.discount_codes[].code` の判定で使う。
	var SPIXN_CODE_PREFIX = 'SPIXN-';
	// Shopify ショップへのログイン/会員登録 URL。`return_to=/cart` で完了後に
	// カート画面に戻り、再度 spixn 即割が利用可能になる。
	// Multi-language ストア (例: /en/cart) では Shopify が return_to を正規化する想定 (要検証)。
	// 新 Customer Accounts (current default) では `/customer_authentication/register` が
	// 存在しないため、SIGNUP も同じ login URL に飛ばす。Shopify ログイン画面側で
	// 新規アカウント作成リンクが用意されている前提。
	var SHOPIFY_LOGIN_URL = '/customer_authentication/login?return_to=%2Fcart';
	var SHOPIFY_REGISTER_URL = SHOPIFY_LOGIN_URL;
	// checkout 時 block 用 alert 文言。
	var SPIXN_WARI_BLOCK_ALERT_MESSAGE =
		'カート金額が即割の利用可能額を下回ったため、spixn 即割を解除しました。'
		+ 'もう一度「購入手続きに進む」を押してください。';
	var SPIXN_WARI_BLOCK_ERROR_ALERT_MESSAGE =
		'カート更新に失敗しました。ページを再読み込みしてから、もう一度お試しください。';
	// セッション切れ検知時の alert 文言 (S1-2581)。
	var SPIXN_WARI_SESSION_EXPIRED_ALERT_MESSAGE =
		'ストアのログインセッションが切れたため、spixn 即割を解除しました。'
		+ 'ログインし直してから、もう一度「購入手続きに進む」を押してください。';

	var spShopId = null;
	var modal = null;
	// iframe 内画面（SignIn/SignUp/Products）から SPIXN_WARI_VIEW_CHANGE で max-width
	// を受け取り更新するため、container 要素も module-scope で保持する。
	var modalContainer = null;
	var iframe = null;
	var handshakeTimer = null;
	var messageListener = null;
	// メインモーダル (a11y / フォーカス復元用)
	var modalKeydownHandler = null;
	var modalPreviouslyFocusedElement = null;
	// App Proxy フロー (S1-2556) — このファイルは App Proxy 必須版。
	// 旧来 Cognito フローは spixn_wari_legacy.js を使う。
	// init 時の oneTimeCodePromise は cleanup 用 session check (cleanupIfSessionExpired
	// の loginStatus 判定) のためだけに使う。iframe へ渡す code は openModal() で
	// モーダルを開く直前に先取りし pendingOneTimeCodeResult に保持、SPIXN_WARI_READY
	// 受信時に postMessage で即時送信する。backend (S1-2581) で 1 customer 複数 OTC を
	// 許可しているため、init 時と modal open 時の fetch は独立した row を作る。
	var oneTimeCodePromise = null;
	// openModal() で先取りした fetchOneTimeCode の結果。READY 受信時に消費する。
	var pendingOneTimeCodeResult = null;
	// openModal の重複起動 (連打 / fetch 中の再クリック) を防ぐフラグ。
	var modalOpenInProgress = false;
	// iframe 内の現在 view (SPIXN_WARI_VIEW_CHANGE で更新)。
	// PRODUCTS は Header/Footer 固定 + List 内部スクロールのため iframe 高さを固定化する必要があり、
	// RESIZE による自動更新を抑止する。closeModal でリセット。
	var SPIXN_WARI_VIEW = { PRODUCTS: 'products' };
	var currentSpixnWariView = null;

	// --- カード登録モーダル用 ---
	var cardModal = null;
	// Stripe Elements は Card Number / Expiry / CVC の 3 要素を別々にマウントするため配列で保持。
	// closeCardModal で全要素を unmount/destroy する。
	var activeCardElements = null;
	var stripeInstance = null;
	var stripeLoadPromise = null;
	var previouslyFocusedElement = null;
	var cardModalKeydownHandler = null;

	// --- SpinCard 用の DOM 参照 ---
	var spinCardEls = null;
	// SpinCard_C (ログイン後・未適用) の「下取り可能残高」テキスト要素。
	// hidden iframe から SPIXN_WARI_AVAILABLE_BALANCE が届いたら textContent を書き換える。
	var spinCardBalanceTextEl = null;

	// --- SpinCard_C 用: ログイン状態と残高キャッシュ ---
	// renderSpinCardForCart は同期的に呼ばれるが、ログイン状態 / 残高は非同期で確定する。
	// 「現在分かっているもの」をキャッシュしておき、確定したタイミングで再描画 or DOM 更新する。
	var cachedLoginStatus = null;       // 'logged_in' | 'no_customer' | 'unknown' | null
	var cachedAvailableBalance = null;  // number | null
	// cachedAvailableBalance がどの excludingDiscountId 用に取得されたか追跡する。
	// SpinCard_C (適用なし) と SpinCard_F (適用済 = excludingDiscountId=その discountId) で
	// 同じ key の場合は再利用、key 変更時は iframe を再起動して再取得する。
	var cachedAvailableBalanceForKey = '';  // '' or excludingDiscountId
	// SpinCard_C / SpinCard_F 用 hidden iframe。ensureBalanceIframe で生成・再生成する。
	var balanceIframe = null;
	var balanceIframeMessageListener = null;
	// 最後に balance iframe へ INIT を送った値 (重複送信防止)。
	var balanceIframeInited = false;
	// renderSpinCardForCart の最終描画時に算出した fingerprint。cart-mutation hook で
	// 「描画に影響する状態に変化が無ければ DOM 再構築を skip」する change-detection guard 用。
	// boolean 2 つだけだと別タブで SPIXN- が入れ替わった等のケース（hasSpixn は true→true 不変
	// だが discountId/totalDiscount/items 数が変わる）を取りこぼすため、applied state の
	// fingerprint も組み込む。
	// 値の形: `${hasNonSpixn}|${hasSpixn}|${discountId}|${totalDiscount}|${itemsLen}`
	// init 前は null。renderSpinCardForCart が呼ばれるたびに最新値で更新される。
	var lastRenderedFingerprint = null;
	// [S1-2657] 非同期描画（pre-order 判定込み）の最新要求を識別する連番。描画要求ごとに ++ し、
	// Promise 解決時に最新と一致する場合のみ描画することで、古い cart スナップショットの遅延解決が
	// 最新状態を上書きするレースを防ぐ。
	var spinCardRenderSeq = 0;

	// --- ロギング ---
	function log(message, context) {
		if (!DEBUG_MODE) return;
		if (context !== undefined) {
			console.log('[SpixnWari] ' + message, context);
		} else {
			console.log('[SpixnWari] ' + message);
		}
	}

	// --- モーダルを閉じる ---
	function closeModal() {
		if (!modal) return;
		closeCardModal();
		if (handshakeTimer) {
			clearTimeout(handshakeTimer);
			handshakeTimer = null;
		}
		if (messageListener) {
			window.removeEventListener('message', messageListener);
			messageListener = null;
		}
		if (modalKeydownHandler) {
			document.removeEventListener('keydown', modalKeydownHandler);
			modalKeydownHandler = null;
		}
		// 外部要因で既に DOM ツリーから外れている可能性に備えて parentNode をチェック。
		// 例外で以降のクリーンアップ（overflow 復元・フォーカス復元）が止まらないようにする。
		if (modal.parentNode) {
			modal.parentNode.removeChild(modal);
		}
		modal = null;
		modalContainer = null;
		iframe = null;
		// 未消費の OTC が残っていれば破棄 (READY 受信前に閉じた場合)
		pendingOneTimeCodeResult = null;
		// 次にモーダルを開いたときに products iframe-height lock 判定が残らないよう view 状態リセット。
		currentSpixnWariView = null;
		document.body.style.overflow = '';
		// 開く前のフォーカス位置に戻す（a11y）
		if (modalPreviouslyFocusedElement && typeof modalPreviouslyFocusedElement.focus === 'function') {
			try { modalPreviouslyFocusedElement.focus(); } catch (e) { /* focus 不能環境では諦める */ }
		}
		modalPreviouslyFocusedElement = null;
		log('モーダルを閉じました');
	}

	// --- ディスカウントコードを適用する ---
	// payload: { code, discountId, selectedItems?, totalDiscount?, availableBalance? }
	// selectedItems / totalDiscount / availableBalance は適用後 SpinCard_F の表示用に
	// cart attribute へ JSON 文字列で保存する。
	function applyDiscountCode(code, discountId, extras) {
		log('ディスカウントコードを適用します', { code: code, discountId: discountId });

		var attributes = {};
		if (discountId) attributes.spixn_wari_discount_id = discountId;
		if (extras && Array.isArray(extras.selectedItems) && extras.selectedItems.length > 0) {
			try {
				// Shopify の cart attribute は値長に制限があるため、保存サイズを最小化する。
				// - productTitle は SpinCard_F でも mini-app pre-select でも使わないので捨てる
				// - imageUrl は SpinCard_F のサムネ用に最初の 3 件だけ保持
				// - lineItemId / discountAmount は pre-select と totalDiscount 復元に必要なので全件保持
				// メッセージ payload は外部入力扱い。lineItemId が string で空でない要素だけ採用する。
				var trimmedItems = extras.selectedItems
					.filter(function(it) {
						return it && typeof it.lineItemId === 'string' && it.lineItemId.length > 0;
					})
					.map(function(it, idx) {
						var entry = {
							lineItemId: it.lineItemId,
							discountAmount: Number(it.discountAmount) || 0,
						};
						if (idx < 3 && typeof it.imageUrl === 'string' && it.imageUrl.length > 0) {
							entry.imageUrl = it.imageUrl;
						}
						return entry;
					});
				attributes.spixn_wari_selected_items = JSON.stringify(trimmedItems);
			} catch (e) { /* JSON.stringify failed: 静かに諦め */ }
		}
		// postMessage 由来の外部入力なので NaN / Infinity を弾いてから保存する。
		if (extras && Number.isFinite(extras.totalDiscount)) {
			attributes.spixn_wari_total_discount = String(extras.totalDiscount);
		}
		if (extras && Number.isFinite(extras.availableBalance)) {
			attributes.spixn_wari_available_balance = String(extras.availableBalance);
		}

		// Shopify の多言語/サブパス構成 (例: /en/) では `routes.root` を経由しないと
		// /cart/update.js が 404 になる場合があるため fetchCartSnapshot と同じ組み立て方に揃える。
		var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		var fallbackUrl = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
		var hasAttrs = Object.keys(attributes).length > 0;

		var sectionPlan = buildCartSectionPlan();
		var url = routesRoot + 'cart/update.js?sections=' + sectionPlan.requestIds.join(',');
		var body = { discount: code };
		if (hasAttrs) body.attributes = attributes;

		fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body),
		}).then(function(res) {
			if (!res.ok) throw new Error('cart/update.js returned ' + res.status);
			return res.json();
		}).then(function(cart) {
			// Shopify は applicable=false のコードでも 200 を返すため、レスポンス内で適用可否を判定。
			// 未適用なら fallback で /discount/<code> を踏ませて Shopify 側のエラー UI に到達させる。
			var applied = cart && Array.isArray(cart.discount_codes) && cart.discount_codes.some(function(d) {
				return d && d.code === code && d.applicable !== false;
			});
			if (!applied) throw new Error('discount code not applicable');

			log('ajax で discount を適用しました', { code: code });

			if (cart.sections) {
				applyCartSections(cart.sections, sectionPlan.swap);
			}

			// セクション差し替えで in-section の SpinCard が消えるため SpinCard_F を再描画。
			// out-of-section ケース向けに renderSpinCardForCart 内で removeExistingSpinCards も走る。
			// extras から組んだ state は parseAppliedSpinCardState が cart attribute 反映遅延で
			// null を返すケースの fallback として override 渡しする。
			var refreshedState = parseAppliedSpinCardState(cart) || buildAppliedStateFromExtras(discountId, extras);
			var newSubtotal = parseCartSubtotal(cart);
			if (typeof newSubtotal === 'number') lastKnownSubtotal = newSubtotal;
			if (cart && cart.token) lastKnownCartToken = cart.token;
			// 適用成功時点の item_count を記録。以後のカート変更検知の基準点となる。
			if (typeof cart.item_count === 'number') lastKnownItemCount = cart.item_count;

			// [S1-2623] renderSpinCardForCart に集約。万一他クーポンが共存していれば非表示優先。
			renderSpinCardForCartGated(cart, newSubtotal, refreshedState);

			closeModal();
		}).catch(function(err) {
			log('ajax 適用に失敗、フルナビにフォールバックします', { error: err && err.message });
			fallbackToFullNav(routesRoot, fallbackUrl, hasAttrs ? attributes : null);
		});
	}

	// extras (postMessage 由来) からは Number.isFinite のサニタイズが必要。
	// parseAppliedSpinCardState が null を返す (cart attribute がまだ伝播してない) ケースの fallback。
	function buildAppliedStateFromExtras(discountId, extras) {
		var items = (extras && Array.isArray(extras.selectedItems)) ? extras.selectedItems : [];
		var totalDiscount = (extras && Number.isFinite(extras.totalDiscount)) ? extras.totalDiscount : 0;
		var availableBalance = (extras && Number.isFinite(extras.availableBalance)) ? extras.availableBalance : 0;
		return { discountId: discountId, items: items, totalDiscount: totalDiscount, availableBalance: availableBalance };
	}

	// 同 POST で attributes も書いた可能性が高いが network エラー全滅に備えて単独で再書き込み。
	// 成否いずれでも navigate は実行する。
	function fallbackToFullNav(routesRoot, fallbackUrl, attributes) {
		var navigate = function() { window.location.href = fallbackUrl; };
		if (!attributes) {
			navigate();
			return;
		}
		fetch(routesRoot + 'cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ attributes: attributes }),
		}).then(navigate).catch(navigate);
	}

	// --- Section Rendering API へ要求する section ID と swap 先を生 DOM から決める ---
	// `main-cart-items` / `main-cart-footer` のような template 由来 section は、Shopify が
	// `template--<theme_id>__<name>` という compiled ID で render する。file 名で要求すると
	// section blocks (subtotal/discount/checkout 等) を含む template 設定が適用されず空シェルが
	// 返るため、生 DOM の `[id^="shopify-section-"]` を逆引きして compiled ID を使う。
	// `cart-icon-bubble` は header 内 snippet として固有 ID で render されるため file 名で要求し、
	// 生 DOM の `#cart-icon-bubble` 自体に inner を流し込む。
	function buildCartSectionPlan() {
		// 各 entry は live DOM から swap 先と要求 ID を導出する resolve を持つ。
		var resolvers = [
			// Dawn 系テーマで section file 内に `id="<name>"` の root 要素がある section
			{ name: 'main-cart-items', resolve: resolveTemplateSection },
			{ name: 'main-cart-footer', resolve: resolveTemplateSection },
			// 単独 section 扱いされない snippet (ヘッダ内に inline 描画される)
			{ name: 'cart-icon-bubble', resolve: resolveSnippetSection },
		];
		var swap = [];
		resolvers.forEach(function(entry) {
			var plan = entry.resolve(entry.name);
			if (plan) swap.push(plan);
		});
		return { requestIds: swap.map(function(p) { return p.id; }), swap: swap };
	}

	function resolveTemplateSection(innerId) {
		var inner = document.getElementById(innerId);
		if (!inner) return null;
		var wrapper = inner.closest('[id^="shopify-section-"]');
		if (!wrapper) return null;
		return { id: wrapper.id.replace(/^shopify-section-/, ''), target: wrapper };
	}

	function resolveSnippetSection(name) {
		var live = document.getElementById(name);
		if (!live) return null;
		return { id: name, target: live };
	}

	// 要素自体を replaceWith しないのは、Dawn の web component (cart-items 等) の
	// disconnect/connect を新しい子に対して走らせて custom element 側の再初期化に任せるため。
	function applyCartSections(sections, swap) {
		swap.forEach(function(plan) {
			var html = sections[plan.id];
			if (typeof html !== 'string' || html.length === 0) return;
			try {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				var fresh = doc.getElementById('shopify-section-' + plan.id);
				if (!fresh) return;
				plan.target.innerHTML = fresh.innerHTML;
			} catch (e) {
				log('section の差し替えに失敗', { id: plan.id, error: e && e.message });
			}
		});
	}

	// --- SpinCard レスポンシブ用 CSS を一度だけ注入する ---
	// インラインスタイルがデスクトップ既定値。クラス + @media (max-width: 767.98px) で
	// モバイル時のみ override する設計。SpinCard_A / SpinCard_C / SpinCard_F の 3 種類で
	// 共通の column 化 + CTA full-width 化を行い、個別差分はサフィックス付きクラスで吸収。
	function ensureSpinCardStylesInjected() {
		if (document.getElementById('spixn-wari-spin-card-styles')) return;
		var style = document.createElement('style');
		style.id = 'spixn-wari-spin-card-styles';
		style.textContent = [
			'@media (max-width: 767.98px) {',
			// 外枠: row -> column。alignItems: stretch をやめて子は full-width で並ぶ。
			'  [data-spixn-wari-spin-card].spixn-wari-sc-root {',
			'    flex-direction: column !important;',
			'    align-items: stretch !important;',
			'  }',
			// 右パネル: row -> column。gap を 12 に縮める (Figma mobile)。
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-right {',
			'    flex-direction: column !important;',
			'    width: 100% !important;',
			'    box-sizing: border-box !important;',
			'    gap: 12px !important;',
			'    flex-shrink: 1 !important;',
			'  }',
			// CTA: hug -> full-width / height 48。SpinCard_A/C/F 共通。
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-cta {',
			'    width: 100% !important;',
			'    height: 48px !important;',
			'    box-sizing: border-box !important;',
			'    flex-shrink: 0 !important;',
			'  }',
			// SpinCard_A: trade-in テキストサイズ 14/1.714 -> 12/1.667。
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-tradein {',
			'    font-size: 12px !important;',
			'    line-height: 1.667 !important;',
			'  }',
			// SpinCard_C/F: amount block / balance text を中央寄せ。
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-amount-block {',
			'    align-items: center !important;',
			'  }',
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-balance {',
			'    text-align: center !important;',
			'  }',
			// SpinCard_F: 縦区切り線を非表示にし、サムネ行を full-width 化。
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-divider {',
			'    display: none !important;',
			'  }',
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-thumbs {',
			'    width: 100% !important;',
			'  }',
			// SpinCard_F: CTA ラップ (バッジ position absolute 用) を full-width に。',
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-cta-wrap {',
			'    width: 100% !important;',
			'  }',
			// SpinCard_F: mobile では header から「適用中」を外し、AmountRow + ProgressBar を出す。
			// (Figma 7533:12087 仕様。desktop ではこれらは display:none のままにする)
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-title-suffix {',
			'    display: none !important;',
			'  }',
			// SpinCard_F: mobile header font-size 16 -> 18 (Figma mobile 7533:12087 style_B6OA19 = 18/700)
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-applied-title {',
			'    font-size: 18px !important;',
			'  }',
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-mobile-flex {',
			'    display: flex !important;',
			'  }',
			'  [data-spixn-wari-spin-card] .spixn-wari-sc-mobile-block {',
			'    display: block !important;',
			'  }',
			'}',
		].join('\n');
		document.head.appendChild(style);
	}

	// merchant カスタム DOM で挿入先がセクション外だったケースに備えた防御的除去。
	// in-section のものは applyCartSections で消える。
	function removeExistingSpinCards() {
		var existing = document.querySelectorAll('[data-spixn-wari-spin-card]');
		for (var i = 0; i < existing.length; i++) {
			if (existing[i].parentNode) existing[i].parentNode.removeChild(existing[i]);
		}
	}

	// --- iframeにメッセージを送信する ---
	function sendToIframe(type, payload) {
		if (!iframe || !iframe.contentWindow) {
			log('iframe が見つかりません。メッセージ送信をスキップします', { type: type });
			return;
		}
		var message = { type: type };
		if (payload) {
			message.payload = payload;
		}
		iframe.contentWindow.postMessage(message, iframeBaseUrl);
		// cartToken / oneTimeCode はログから除外する（機微情報のため）
		var logPayload = message.payload;
		if (logPayload && (logPayload.cartToken || logPayload.oneTimeCode)) {
			var redacted = Object.assign({}, logPayload);
			if (redacted.cartToken) redacted.cartToken = '[redacted]';
			if (redacted.oneTimeCode) redacted.oneTimeCode = '[redacted]';
			logPayload = redacted;
		}
		log('iframeにメッセージを送信しました', Object.assign({}, message, { payload: logPayload }));
	}

	// [T1-660] 表示ファネル step0: SpixnCard が表示された = 分母。
	// cart 単位で 1 回だけ display-log へ送る。best-effort / fire-and-forget。
	// 描画・購買フローをブロックしない。iframeBaseUrl 未確定時 / cart_token 無し時は送らない。
	function sendSpixncardShownLog() {
		if (!iframeBaseUrl) return;
		if (!spShopId) return;
		if (!lastKnownCartToken) return;
		if (spixncardShownSentCartToken === lastKnownCartToken) return;
		spixncardShownSentCartToken = lastKnownCartToken;
		// reject は空 catch で握りつぶす（fetch は同期 throw しない前提）。
		fetch(iframeBaseUrl + '/api/spixn-wari/display-log', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			keepalive: true,
			body: JSON.stringify({
				event_type: 'spixncard/shown',
				sp_shop_id: spShopId,
				cart_token: lastKnownCartToken
			})
		}).catch(function() {});
	}

	// --- postMessage のバリデーション ---
	function isValidMessage(event) {
		if (event.origin !== iframeBaseUrl) {
			log('不正なオリジン、無視します', { origin: event.origin });
			return false;
		}
		// 送信元 window が想定の iframe であることを確認（同一originの別フレームからのメッセージ偽造を防止）
		if (iframe && iframe.contentWindow && event.source !== iframe.contentWindow) {
			log('送信元 window が iframe と一致しません', { source: event.source });
			return false;
		}
		var data = event.data;
		if (!data || typeof data.type !== 'string' || !data.type.startsWith('SPIXN_WARI_')) {
			log('無効なメッセージ形式、無視します', { data: data });
			return false;
		}
		return true;
	}

	// --- Stripe.js を動的にロードする ---
	function loadStripeJs() {
		if (stripeLoadPromise) return stripeLoadPromise;

		stripeLoadPromise = new Promise(function(resolve, reject) {
			if (window.Stripe) {
				resolve(window.Stripe);
				return;
			}

			var script = document.createElement('script');
			script.src = 'https://js.stripe.com/v3/';
			script.async = true;

			function cleanupScript() {
				script.onload = null;
				script.onerror = null;
				if (script.parentNode) {
					script.parentNode.removeChild(script);
				}
			}

			var timeout = setTimeout(function() {
				stripeLoadPromise = null;
				cleanupScript();
				reject(new Error('Stripe.js の読み込みがタイムアウトしました'));
			}, 10000);

			script.onload = function() {
				clearTimeout(timeout);
				if (window.Stripe) {
					resolve(window.Stripe);
				} else {
					stripeLoadPromise = null;
					cleanupScript();
					reject(new Error('Stripe.js の初期化に失敗しました'));
				}
			};

			script.onerror = function() {
				clearTimeout(timeout);
				stripeLoadPromise = null;
				cleanupScript();
				reject(new Error('Stripe.js の読み込みに失敗しました'));
			};

			document.head.appendChild(script);
		});

		return stripeLoadPromise;
	}

	// --- カード登録モーダル レスポンシブ用 CSS を一度だけ注入 ---
	// インラインスタイルが desktop 既定値、mobile (≤767.98px) はクラス + @media で上書きする。
	// Figma Mobile (7552:18113): Title 16px / Cancel 16px / brand icon 20x20 / cancel section gap 16
	// 各セクションの水平 padding は desktop 32px / mobile 24px (header 32/24・form 0/24・cancel 0/24/32)
	function ensureCardModalStylesInjected() {
		if (document.getElementById('spixn-wari-card-modal-styles')) return;
		var style = document.createElement('style');
		style.id = 'spixn-wari-card-modal-styles';
		style.textContent = [
			'@media (max-width: 767.98px) {',
			'  .spixn-wari-cm-title {',
			'    font-size: 16px !important;',
			'  }',
			'  .spixn-wari-cm-cancel {',
			'    font-size: 16px !important;',
			'  }',
			'  .spixn-wari-cm-header {',
			'    padding: 32px 24px !important;',
			'  }',
			'  .spixn-wari-cm-form-section {',
			'    padding: 0 24px !important;',
			'  }',
			'  .spixn-wari-cm-cancel-section {',
			'    gap: 16px !important;',
			'    padding: 0 24px 32px !important;',
			'  }',
			'  .spixn-wari-cm-brand-icon {',
			'    width: 20px !important;',
			'    height: 20px !important;',
			'  }',
			// Submit / cancel buttons: mobile では Figma 標準の h 48 (= 縦 padding 0 + 高さ 48) に揃える。
			// desktop は inline style の padding 16/24 で従来 hug 挙動を維持。
			'  .spixn-wari-cm-submit, .spixn-wari-cm-cancel {',
			'    height: 48px !important;',
			'    padding: 0 24px !important;',
			'    display: flex !important;',
			'    align-items: center !important;',
			'    justify-content: center !important;',
			'  }',
			'}',
		].join('\n');
		document.head.appendChild(style);
	}

	// --- カード登録モーダルを閉じる ---
	function closeCardModal() {
		if (!cardModal) return;
		if (activeCardElements && activeCardElements.length > 0) {
			activeCardElements.forEach(function(el) {
				try { el.unmount(); } catch (e) { /* unmount 失敗は無視 */ }
				try { el.destroy(); } catch (e) { /* destroy 失敗も無視 */ }
			});
			activeCardElements = null;
		}
		if (cardModalKeydownHandler) {
			document.removeEventListener('keydown', cardModalKeydownHandler, true);
			cardModalKeydownHandler = null;
		}
		// 背景モーダル（spixn割モーダル）を支援技術に再度露出させる
		if (modal) {
			modal.removeAttribute('aria-hidden');
		}
		// 二重 close 等で既に DOM から外れているケースを安全にハンドル
		if (cardModal.parentNode) {
			cardModal.parentNode.removeChild(cardModal);
		}
		cardModal = null;
		// カード登録モーダル起動前にフォーカスしていた要素に戻す
		if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
			try {
				previouslyFocusedElement.focus();
			} catch (e) {
				// フォーカス復元失敗は致命的ではないので無視
			}
		}
		previouslyFocusedElement = null;
		log('カード登録モーダルを閉じました');
	}

	// --- カード登録モーダルを開く ---
	// mode:
	//   - 'register': 新規登録 (タイトル「クレジットカード登録（スピン即割用）」、CTA「クレジットカードを登録する」)
	//   - 'update':   期限切れカード更新 (タイトル「クレジットカード情報の更新（スピン即割用）」、CTA「クレジットカードを更新する」)
	// 未指定 / 不明値の場合は 'register' にフォールバック (後方互換)。
	function openCardRegistrationModal(clientSecret, mode) {
		if (cardModal) return;
		var modalMode = mode === 'update' ? 'update' : 'register';
		log('カード登録モーダルを開きます', { mode: modalMode });
		ensureCardModalStylesInjected();

		if (!stripePublishableKey) {
			console.error('[SpixnWari] stripePublishableKey が未設定です。SpixnWari.initialize() の options.stripePublishableKey を確認してください。');
			var configErrMessage = 'カード登録画面の設定に不備があります。ショップ管理者にお問い合わせください。';
			showModalError(configErrMessage);
			sendToIframe('SPIXN_WARI_ERROR', { message: configErrMessage });
			sendToIframe('SPIXN_WARI_CARD_REGISTRATION_CANCELLED');
			return;
		}

		// リクエスト毎のトークン。Stripe.js の非同期ロード中に parent モーダルが閉じられた場合、
		// then 内で modal が null になっていることを確認し、カード登録モーダルの生成を中止する。
		var requestModal = modal;

		loadStripeJs().then(function(Stripe) {
			// ロード中にspixn割モーダル自体が閉じられた or 別のリクエストに切り替わった場合はキャンセル
			if (!modal || modal !== requestModal) {
				log('spixn割モーダルが閉じられたためカード登録モーダル生成をキャンセルしました');
				return;
			}
			if (!stripeInstance) {
				stripeInstance = Stripe(stripePublishableKey);
			}

			// Stripe Elements は cardNumber / cardExpiry / cardCvc の 3 要素に分けてマウントし、
			// Figma デザイン (上段=カード番号 + ブランドアイコン、下段=有効期限 / CVC) の構造に合わせる。
			// confirmCardSetup には cardNumber 要素を渡せば Stripe が他の要素から expiry/cvc を引き当てる。
			var elementsInstance = stripeInstance.elements({ locale: 'ja' });
			// Figma の form text style: Noto Sans JP / 500 / 16px / line-height 1.46 / #2B2B2B
			var stripeBaseStyle = {
				base: {
					fontFamily: '"Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
					fontSize: '16px',
					fontWeight: '500',
					lineHeight: '1.46',
					color: '#2B2B2B',
					'::placeholder': { color: '#939096' },
				},
				invalid: { color: '#c0392b' },
			};
			// Figma `6240:40734`: 4 ブランドアイコン (VISA/MC/AMEX/JCB) を常時表示するため
			// Stripe デフォルトの単一カード brand icon は disable する。
			var cardNumberElement = elementsInstance.create('cardNumber', {
				style: stripeBaseStyle,
				showIcon: false,
				placeholder: '1234 1234 1234 1234',
			});
			var cardExpiryElement = elementsInstance.create('cardExpiry', {
				style: stripeBaseStyle,
				placeholder: 'MM / YY',
			});
			var cardCvcElement = elementsInstance.create('cardCvc', {
				style: stripeBaseStyle,
				placeholder: 'CVC',
			});

			// 起動前にフォーカスしていた要素を記憶し、閉じた時に戻す
			previouslyFocusedElement = document.activeElement;

			// オーバーレイ（a11y: dialog / aria-modal）
			var titleId = 'spixn-wari-card-modal-title-' + Date.now();
			cardModal = document.createElement('div');
			cardModal.setAttribute('role', 'dialog');
			cardModal.setAttribute('aria-modal', 'true');
			cardModal.setAttribute('aria-labelledby', titleId);
			cardModal.style.cssText = [
				'position: fixed',
				'top: 0',
				'left: 0',
				'width: 100%',
				'height: 100%',
				'background: rgba(0, 0, 0, 0.5)',
				'z-index: 10002',
				'display: flex',
				'align-items: center',
				'justify-content: center',
				'font-family: "Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
			].join(';');

			// コンテナ (Figma: 480px / 24px radius / 32px gap / shadow)
			var container = document.createElement('div');
			container.style.cssText = [
				'position: relative',
				'background: #fff',
				'border-radius: 24px',
				'box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08)',
				'width: 90%',
				'max-width: 480px',
				'max-height: 90vh',
				'overflow-y: auto',
				'z-index: 10003',
				'box-sizing: border-box',
				'display: flex',
				'flex-direction: column',
				'gap: 32px',
				'padding: 0',
			].join(';');

			// --- Header (Figma: padding 32, gap 8, bottom border) ---
			var header = document.createElement('div');
			header.style.cssText = [
				'position: relative',
				'display: flex',
				'flex-direction: column',
				'gap: 8px',
				'padding: 32px',
				'border-bottom: 1px solid #E4E4E5',
				'box-sizing: border-box',
			].join(';');
			header.className = 'spixn-wari-cm-header';

			var title = document.createElement('h2');
			title.id = titleId;
			title.textContent =
				modalMode === 'update'
					? 'クレジットカード情報の更新（スピン即割用）'
					: 'クレジットカード登録（スピン即割用）';
			title.className = 'spixn-wari-cm-title';
			title.style.cssText = [
				'margin: 0',
				'font-family: "Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
				'font-size: 20px',
				'font-weight: 700',
				'line-height: 1.448',
				'color: #2B2B2B',
			].join(';');

			var desc = document.createElement('p');
			desc.textContent =
				'スピン即割は、お手元のアイテムをお送りいただく前に、割引が適用されるサービスです。'
				+ '本サービスは、spixn（リベロント株式会社）が提供しております。';
			desc.style.cssText = [
				'margin: 0',
				'font-family: "Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
				'font-size: 14px',
				'font-weight: 400',
				'line-height: 1.4286',
				'color: #67636B',
			].join(';');

			// --- 注意書きアコーディオン (Figma 7839:663 / 7937:1387 等) ---
			// header (1 行 + chevron) + body (展開時のみ表示、4 行注釈)。bg #FBFBFB Gray 0 / br 12。
			var noticeBox = document.createElement('div');
			noticeBox.style.cssText = [
				'background: #FBFBFB',
				'border-radius: 12px',
				'padding: 12px 16px',
				'box-sizing: border-box',
				'display: flex',
				'flex-direction: column',
				'gap: 8px',
			].join(';');

			// noticeBody の id を先に作って noticeHeader の aria-controls に紐付ける (a11y)。
			// titleId と同じく Date.now() を含めて modal インスタンス間で衝突しないようにする。
			var noticeBodyId = 'spixn-wari-card-modal-notice-body-' + Date.now();
			var noticeHeader = document.createElement('button');
			noticeHeader.type = 'button';
			noticeHeader.setAttribute('aria-expanded', 'false');
			noticeHeader.setAttribute('aria-controls', noticeBodyId);
			noticeHeader.style.cssText = [
				'background: none',
				'border: none',
				'padding: 0',
				'margin: 0',
				'display: flex',
				'justify-content: space-between',
				'align-items: flex-start',
				'gap: 8px',
				'cursor: pointer',
				'text-align: left',
				'width: 100%',
				'font-family: inherit',
			].join(';');
			var noticeHeaderText = document.createElement('span');
			noticeHeaderText.textContent =
				'スピン即割は正常にお取り引きが完了した場合、ご登録いただいたクレジットカードへのご請求は一切発生いたしません。';
			noticeHeaderText.style.cssText = [
				'flex: 1 1 auto',
				'font-family: "Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
				'font-size: 14px',
				'font-weight: 700',
				'line-height: 1.4286',
				'color: #2B2B2B',
			].join(';');
			// chevron-down (24x24 SVG)。アコーディオン展開時に 180° 回転させる。
			var noticeChevron = document.createElement('span');
			noticeChevron.setAttribute('aria-hidden', 'true');
			noticeChevron.innerHTML =
				'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
				+ '<path d="M6 9L12 15L18 9" stroke="#2B2B2B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
				+ '</svg>';
			noticeChevron.style.cssText = [
				'flex-shrink: 0',
				'display: inline-flex',
				'transition: transform 0.2s ease',
			].join(';');
			noticeHeader.appendChild(noticeHeaderText);
			noticeHeader.appendChild(noticeChevron);

			var noticeBody = document.createElement('p');
			noticeBody.id = noticeBodyId;
			noticeBody.hidden = true;
			noticeBody.textContent =
				'ただし、以下に該当する場合にのみ、適用された割引額をご請求させていただきます。\n'
				+ '・アイテムが未発送または誤送の場合\n'
				+ '・アイテムが状態不良の判定となった場合\n'
				+ '・本人確認未完了の場合\n'
				+ '・その他不適切な利用で取引が不成立の場合';
			noticeBody.style.cssText = [
				'margin: 0',
				'white-space: pre-line',
				'font-family: "Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
				'font-size: 14px',
				'font-weight: 400',
				'line-height: 1.4286',
				'color: #67636B',
			].join(';');

			noticeHeader.addEventListener('click', function() {
				var expanded = noticeHeader.getAttribute('aria-expanded') === 'true';
				var next = !expanded;
				noticeHeader.setAttribute('aria-expanded', String(next));
				// hidden 属性 / aria 状態を同期する。display: none は hidden 属性で代替できるので
				// inline style では制御せず、ブラウザのデフォルトに任せる。
				noticeBody.hidden = !next;
				noticeChevron.style.transform = next ? 'rotate(180deg)' : '';
			});

			noticeBox.appendChild(noticeHeader);
			noticeBox.appendChild(noticeBody);

			// 閉じるボタン (Figma: 40x40 円, #F2F2F2 bg, position absolute x:430 y:10.12)
			// X icon は 14x14 SVG (stroke #67636B / 2px / round)
			var closeBtn = document.createElement('button');
			closeBtn.type = 'button';
			closeBtn.setAttribute('aria-label', '閉じる');
			closeBtn.innerHTML =
				'<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">'
				+ '<path d="M2 2L12 12M12 2L2 12" stroke="#67636B" stroke-width="2" stroke-linecap="round"/>'
				+ '</svg>';
			closeBtn.style.cssText = [
				'position: absolute',
				'top: 10px',
				'right: 10px',
				'width: 40px',
				'height: 40px',
				'border-radius: 80px',
				'background: #F2F2F2',
				'border: none',
				'cursor: pointer',
				'display: flex',
				'align-items: center',
				'justify-content: center',
				'padding: 0',
			].join(';');

			header.appendChild(title);
			header.appendChild(desc);
			header.appendChild(noticeBox);
			header.appendChild(closeBtn);

			// --- カード入力フォーム (Figma: padding 0 32, gap 16) ---
			var formSection = document.createElement('div');
			formSection.style.cssText = [
				'display: flex',
				'flex-direction: column',
				'gap: 16px',
				'padding: 0 32px',
				'box-sizing: border-box',
			].join(';');
			formSection.className = 'spixn-wari-cm-form-section';

			// フォーム枠 (1px border #DCDADE, 12px radius)
			var formBox = document.createElement('div');
			formBox.style.cssText = [
				'border: 1px solid #DCDADE',
				'border-radius: 12px',
				'overflow: hidden',
				'background: #fff',
			].join(';');

			// 上段: カード番号 (12px 16px padding, 下に 1px border)
			var numberRow = document.createElement('div');
			numberRow.style.cssText = [
				'display: flex',
				'align-items: center',
				'padding: 12px 16px',
				'border-bottom: 1px solid #DCDADE',
				'box-sizing: border-box',
				'gap: 12px',
			].join(';');
			var numberMount = document.createElement('div');
			numberMount.style.cssText = 'flex: 1 1 auto; min-width: 0';
			numberRow.appendChild(numberMount);

			// Figma `6240:40734`: VISA / Mastercard / AMEX / JCB の 4 ブランドアイコンを常時表示。
			// desktop 36×36、mobile 20×20 (class .spixn-wari-cm-brand-icon の @media で切替)。
			// Stripe の card brand icon (showIcon=false) と区別するため自前 SVG を並べる。
			var brandIconsRow = document.createElement('div');
			brandIconsRow.style.cssText = ['display: flex', 'align-items: center', 'gap: 4px', 'flex-shrink: 0'].join(';');
			var BRAND_ICONS = [
				// VISA
				'<svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="36" height="24" rx="4" fill="#1A1F71"/><text x="18" y="16" font-family="Arial,sans-serif" font-size="9" font-weight="900" fill="#fff" text-anchor="middle">VISA</text></svg>',
				// Mastercard
				'<svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="36" height="24" rx="4" fill="#fff" stroke="#DCDADE"/><circle cx="15" cy="12" r="6" fill="#EB001B"/><circle cx="21" cy="12" r="6" fill="#F79E1B" fill-opacity="0.85"/></svg>',
				// AMEX
				'<svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="36" height="24" rx="4" fill="#2E77BB"/><text x="18" y="16" font-family="Arial,sans-serif" font-size="7" font-weight="900" fill="#fff" text-anchor="middle">AMEX</text></svg>',
				// JCB
				'<svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="36" height="24" rx="4" fill="#fff" stroke="#DCDADE"/><rect x="2" y="2" width="10" height="20" rx="2" fill="#0E4C96"/><rect x="13" y="2" width="10" height="20" rx="2" fill="#C8102E"/><rect x="24" y="2" width="10" height="20" rx="2" fill="#00A551"/><text x="18" y="15" font-family="Arial,sans-serif" font-size="6" font-weight="900" fill="#fff" text-anchor="middle">JCB</text></svg>',
			];
			BRAND_ICONS.forEach(function(svg) {
				var slot = document.createElement('span');
				slot.className = 'spixn-wari-cm-brand-icon';
				slot.setAttribute('aria-hidden', 'true');
				slot.style.cssText = [
					'display: inline-flex',
					'align-items: center',
					'justify-content: center',
					'width: 36px',
					'height: 36px',
					'flex-shrink: 0',
				].join(';');
				slot.innerHTML = svg;
				var svgEl = slot.querySelector('svg');
				if (svgEl) {
					svgEl.style.width = '100%';
					svgEl.style.height = 'auto';
				}
				brandIconsRow.appendChild(slot);
			});
			numberRow.appendChild(brandIconsRow);

			// 下段: 有効期限 / CVC (左右 split with 1px border)
			var bottomRow = document.createElement('div');
			bottomRow.style.cssText = [
				'display: flex',
				'box-sizing: border-box',
			].join(';');
			var expiryCell = document.createElement('div');
			expiryCell.style.cssText = [
				'flex: 1 1 50%',
				'padding: 12px 16px',
				'box-sizing: border-box',
			].join(';');
			var cvcCell = document.createElement('div');
			cvcCell.style.cssText = [
				'flex: 1 1 50%',
				'padding: 12px 16px',
				'border-left: 1px solid #DCDADE',
				'box-sizing: border-box',
			].join(';');
			bottomRow.appendChild(expiryCell);
			bottomRow.appendChild(cvcCell);

			formBox.appendChild(numberRow);
			formBox.appendChild(bottomRow);

			// エラーメッセージ
			var errorDiv = document.createElement('div');
			errorDiv.setAttribute('role', 'alert');
			errorDiv.setAttribute('aria-live', 'assertive');
			errorDiv.setAttribute('aria-atomic', 'true');
			errorDiv.style.cssText = [
				'color: #c0392b',
				'font-size: 13px',
				'min-height: 0',
				'line-height: 1.4',
			].join(';');

			// 登録 / 更新ボタン (Blue green #02BCAC, 12px radius, Noto Sans JP / 600 / 18px / line 1.448)
			// Figma `6240:40781`: 初期状態は opacity 0.32 (validation 完了で 1 に遷移)
			// mobile では @media (ensureCardModalStylesInjected) で h 48 + 縦 padding 0 に上書き。
			var submitLabel = modalMode === 'update' ? 'クレジットカードを更新する' : 'クレジットカードを登録する';
			var submitBtn = document.createElement('button');
			submitBtn.type = 'button';
			submitBtn.textContent = submitLabel;
			submitBtn.disabled = true;
			submitBtn.className = 'spixn-wari-cm-submit';
			submitBtn.style.cssText = [
				'display: block',
				'width: 100%',
				'background: #02BCAC',
				'color: #fff',
				'border: none',
				'border-radius: 12px',
				'padding: 16px 24px',
				'font-family: "Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
				'font-size: 18px',
				'font-weight: 600',
				'line-height: 1.448',
				'cursor: not-allowed',
				'opacity: 0.32',
				'box-sizing: border-box',
			].join(';');

			formSection.appendChild(formBox);
			formSection.appendChild(errorDiv);
			formSection.appendChild(submitBtn);

			// --- キャンセルボタン (Figma: 別セクション, padding 0 32 32, gap 24 / mobile gap 16) ---
			var cancelSection = document.createElement('div');
			cancelSection.className = 'spixn-wari-cm-cancel-section';
			cancelSection.style.cssText = [
				'display: flex',
				'flex-direction: column',
				'gap: 24px',
				'padding: 0 32px 32px',
				'box-sizing: border-box',
			].join(';');

			var cancelBtn = document.createElement('button');
			cancelBtn.type = 'button';
			cancelBtn.textContent = 'キャンセル';
			cancelBtn.className = 'spixn-wari-cm-cancel';
			cancelBtn.style.cssText = [
				'display: block',
				'width: 100%',
				'background: #fff',
				'color: #67636B',
				'border: 2px solid #E4E4E5',
				'border-radius: 12px',
				'padding: 16px 24px',
				'font-family: "Noto Sans JP", "Hiragino Sans", "Yu Gothic", sans-serif',
				'font-size: 18px',
				'font-weight: 600',
				'line-height: 1.448',
				'cursor: pointer',
				'box-sizing: border-box',
			].join(';');
			cancelSection.appendChild(cancelBtn);

			// Stripe Elements の validation 完了状態を購読し、全 3 要素 complete のとき
			// submit を enabled (opacity 1) に切り替える。Figma `6240:40781` の disabled→enabled
			// 表示遷移と対応。
			var formValidity = { cardNumber: false, cardExpiry: false, cardCvc: false };
			function updateSubmitButtonEnabled() {
				var allComplete = formValidity.cardNumber && formValidity.cardExpiry && formValidity.cardCvc;
				submitBtn.disabled = !allComplete;
				submitBtn.style.opacity = allComplete ? '1' : '0.32';
				submitBtn.style.cursor = allComplete ? 'pointer' : 'not-allowed';
			}
			cardNumberElement.on('change', function(e) { formValidity.cardNumber = !!e.complete; updateSubmitButtonEnabled(); });
			cardExpiryElement.on('change', function(e) { formValidity.cardExpiry = !!e.complete; updateSubmitButtonEnabled(); });
			cardCvcElement.on('change', function(e) { formValidity.cardCvc = !!e.complete; updateSubmitButtonEnabled(); });

			// 登録ボタンハンドラ
			var submitting = false;
			submitBtn.addEventListener('click', function() {
				if (submitting) return;
				submitting = true;
				submitBtn.disabled = true;
				submitBtn.style.opacity = '0.6';
				submitBtn.style.cursor = 'wait';
				submitBtn.textContent = '処理中...';
				errorDiv.textContent = '';

				stripeInstance.confirmCardSetup(clientSecret, {
					payment_method: { card: cardNumberElement },
				}).then(function(result) {
					if (result.error) {
						errorDiv.textContent = result.error.message || 'カードの登録に失敗しました';
						submitting = false;
						submitBtn.disabled = false;
						submitBtn.style.opacity = '';
						submitBtn.style.cursor = 'pointer';
						submitBtn.textContent = submitLabel;
					} else {
						log('カード登録成功', { setupIntentId: result.setupIntent.id });
						closeCardModal();
						sendToIframe('SPIXN_WARI_CARD_REGISTERED');
					}
				}).catch(function(err) {
					errorDiv.textContent = err.message || 'カードの登録に失敗しました';
					submitting = false;
					submitBtn.disabled = false;
					submitBtn.style.opacity = '';
					submitBtn.style.cursor = 'pointer';
					submitBtn.textContent = submitLabel;
				});
			});

			// キャンセル・閉じる共通動作
			function dismissCardModal() {
				closeCardModal();
				sendToIframe('SPIXN_WARI_CARD_REGISTRATION_CANCELLED');
			}
			cancelBtn.addEventListener('click', dismissCardModal);
			closeBtn.addEventListener('click', dismissCardModal);

			// オーバーレイクリックで閉じる
			cardModal.addEventListener('click', function(e) {
				if (e.target === cardModal) {
					dismissCardModal();
				}
			});

			container.appendChild(header);
			container.appendChild(formSection);
			container.appendChild(cancelSection);
			cardModal.appendChild(container);

			// 背景モーダル（spixn割モーダル）を支援技術から隠す
			if (modal) {
				modal.setAttribute('aria-hidden', 'true');
			}
			document.body.appendChild(cardModal);

			// Stripe Elements をそれぞれマウント
			cardNumberElement.mount(numberMount);
			cardExpiryElement.mount(expiryCell);
			cardCvcElement.mount(cvcCell);
			activeCardElements = [cardNumberElement, cardExpiryElement, cardCvcElement];

			// 初期フォーカス：Stripe Elements iframe にフォーカスを奪わせるため submitBtn を基点にする
			// 実際は cardElement.focus() が使えないため、まずは submitBtn に移す
			try {
				submitBtn.focus();
			} catch (e) {
				// フォーカス失敗は致命的ではないので無視
			}

			// Esc で閉じる／Tab でフォーカストラップ
			cardModalKeydownHandler = function(ev) {
				if (ev.key === 'Escape') {
					ev.preventDefault();
					closeCardModal();
					sendToIframe('SPIXN_WARI_CARD_REGISTRATION_CANCELLED');
					return;
				}
				if (ev.key === 'Tab') {
					// cardModal 内のフォーカス可能要素を取得（Stripe Elements の iframe も含める）
					var focusable = cardModal.querySelectorAll(
						'a[href], button:not([disabled]), textarea, input, select, iframe, [tabindex]:not([tabindex="-1"])'
					);
					if (focusable.length === 0) return;
					var first = focusable[0];
					var last = focusable[focusable.length - 1];
					var active = document.activeElement;
					if (ev.shiftKey) {
						if (active === first || !cardModal.contains(active)) {
							ev.preventDefault();
							last.focus();
						}
					} else {
						if (active === last) {
							ev.preventDefault();
							first.focus();
						}
					}
				}
			};
			document.addEventListener('keydown', cardModalKeydownHandler, true);

			log('カード登録モーダルを表示しました');

		}).catch(function(err) {
			log('Stripe.js ロードエラー', { error: err && err.message });
			var loadErrMessage = 'カード登録画面の読み込みに失敗しました。通信環境やブラウザ設定をご確認のうえ、再度お試しください。';
			showModalError(loadErrMessage);
			sendToIframe('SPIXN_WARI_ERROR', { message: loadErrMessage });
			sendToIframe('SPIXN_WARI_CARD_REGISTRATION_CANCELLED');
		});
	}

	// --- postMessage ハンドラ ---
	function handleMessage(event) {
		if (!isValidMessage(event)) return;

		var data = event.data;
		log('iframeからメッセージを受信しました', data);

		if (data.type === 'SPIXN_WARI_READY') {
			if (handshakeTimer) {
				clearTimeout(handshakeTimer);
				handshakeTimer = null;
			}
			// 「選択を編集」モードで開いた場合、cart attribute から復元した選択商品も同送する。
			// 最新の小計を 1 回 fetch してから INIT を送ることで、iframe 側で旧値→新値の
			// 余計な再描画を発生させない（INIT 直後の冗長な refresh を撤去）。
			fetchCartSnapshot().then(function(cart) {
				var subtotal = parseCartSubtotal(cart);
				lastKnownSubtotal = subtotal;
				lastKnownCartToken = (cart && cart.token) ? cart.token : null;
				updateSpinCardProgress(subtotal);
				var appliedItems = (lastAppliedState && Array.isArray(lastAppliedState.items))
					? lastAppliedState.items
					: null;
				// 編集モード判定用に discountId も同送する。
				// 未適用時は null。mini-app 側で eligible 計算の自身除外 + 解除対象同定に使う。
				var editingDiscountId = (lastAppliedState && typeof lastAppliedState.discountId === 'string')
					? lastAppliedState.discountId
					: null;
				sendToIframe('SPIXN_WARI_INIT', {
					spShopId: spShopId,
					origin: window.location.origin,
					cartSubtotal: subtotal,
					appliedSelectedItems: appliedItems,
					editingDiscountId: editingDiscountId,
					authWithAppProxy: true,
					cartToken: cart && cart.token ? cart.token : null,
				});
				// openModal() で先取りした OTC を consume して即送信。
				// 万一 pending が無い場合 (直接 renderModal が呼ばれた等の異常) はその場で fetch する fallback。
				// status === 'unknown' (5xx / network / timeout) は確定的未ログインではないため
				// SPIXN_WARI_NO_CUSTOMER は送らない (ログイン誘導画面への誤遷移を防ぐ)。
				if (pendingOneTimeCodeResult) {
					dispatchOneTimeCodeToIframe(pendingOneTimeCodeResult);
					pendingOneTimeCodeResult = null;
				} else {
					fetchOneTimeCodeWithStatusSync().then(dispatchOneTimeCodeToIframe);
				}
			});
			return;
		}

		if (data.type === 'SPIXN_WARI_DISCOUNT_APPLY') {
			if (data.payload && data.payload.code && typeof data.payload.code === 'string') {
				var discountId = typeof data.payload.discountId === 'string' ? data.payload.discountId : null;
				var extras = {};
				if (Array.isArray(data.payload.selectedItems)) extras.selectedItems = data.payload.selectedItems;
				if (typeof data.payload.totalDiscount === 'number') extras.totalDiscount = data.payload.totalDiscount;
				if (typeof data.payload.availableBalance === 'number') extras.availableBalance = data.payload.availableBalance;
				applyDiscountCode(data.payload.code, discountId, extras);
			} else {
				log('SPIXN_WARI_DISCOUNT_APPLY: code が無効です', { data: data });
			}
			return;
		}

		// 「選択を編集」 → 選択 0 件「スピン即割を解除する」押下時、mini-app から届く解除通知。
		// バックエンドはこの時点で既に spixn_wari_discount.status=canceled + Shopify ディスカウントコード削除を完了している。
		// storefront 側は cart の SPIXN- discount と spixn_wari_* attributes を落として SpinCard を未適用状態に戻す。
		if (data.type === 'SPIXN_WARI_DISCOUNT_CANCEL') {
			log('スピン即割解除を受信。cart 状態をリセットします', {
				discountId: data.payload && data.payload.discountId,
			});
			// resetSpixnWariCartState は cart fetch から始めるが、これは別途実行中で fail-safe
			// (resetInProgress フラグで gate されているため重複しても early return)。
			// 第 1 引数 cart は cartIsFresh=false のため null/undefined で OK (内部で fetchCartSnapshot)。
			resetSpixnWariCartState(null, /*cartIsFresh=*/false);
			return;
		}

		if (data.type === 'SPIXN_WARI_NAVIGATE_PARENT') {
			// iframe からの依頼で親フレームを Shopify ログイン/会員登録ページへ遷移させる。
			// target が想定外の値の場合は防御的に login にフォールバック。
			var target = data.payload && data.payload.target;
			var url = target === 'signup' ? SHOPIFY_REGISTER_URL : SHOPIFY_LOGIN_URL;
			log('親フレームを Shopify ログイン/会員登録へ遷移します', { target: target, url: url });
			window.location.href = url;
			return;
		}

		if (data.type === 'SPIXN_WARI_CLOSE') {
			closeModal();
			return;
		}

		if (data.type === 'SPIXN_WARI_RESIZE') {
			// products view では iframe 高さを VIEW_CHANGE で固定化済。RESIZE で上書きすると
			// ItemModal 側の h-screen レイアウト (List 内部スクロール) と衝突して無限拡大ループや
			// 二重スクロールバーが起きるためスキップ。
			if (currentSpixnWariView === SPIXN_WARI_VIEW.PRODUCTS) return;
			if (iframe && data.payload && typeof data.payload.height === 'number') {
				iframe.style.height = data.payload.height + 'px';
				log('iframeの高さを変更しました', { height: data.payload.height });
			}
			return;
		}

		if (data.type === 'SPIXN_WARI_VIEW_CHANGE') {
			currentSpixnWariView = (data.payload && typeof data.payload.view === 'string')
				? data.payload.view
				: null;
			// iframe 側の現在画面に応じた推奨幅で modal container の最大幅を更新する。
			// 想定外の値を弾くため数値で 320–1200 にクランプする。
			var w = data.payload && data.payload.preferredMaxWidth;
			if (modalContainer && typeof w === 'number' && Number.isFinite(w)) {
				var clamped = Math.max(320, Math.min(1200, w));
				modalContainer.style.maxWidth = clamped + 'px';
				log('modal container の maxWidth を更新しました', { view: data.payload.view, maxWidth: clamped });
			}
			// products view: ItemModal は Header/Footer 固定 + List 内部スクロールにするため
			// iframe 高さを window viewport に基づく固定値で lock する。RESIZE は無視 (上記参照)。
			if (iframe && currentSpixnWariView === SPIXN_WARI_VIEW.PRODUCTS) {
				var lockedHeight = Math.floor(Math.min(900, window.innerHeight * 0.85));
				iframe.style.height = lockedHeight + 'px';
				log('products view: iframe 高さを固定しました', { height: lockedHeight });
			}
			return;
		}

		if (data.type === 'SPIXN_WARI_ERROR') {
			var errMessage = (data.payload && data.payload.message) || 'エラーが発生しました。再度お試しください。';
			log('iframeからエラーを受信しました', { message: errMessage });
			// カード登録モーダルが開いている場合は閉じてからメッセージを spixn割モーダル側に表示
			if (cardModal) {
				closeCardModal();
			}
			showModalError(errMessage);
			return;
		}

		if (data.type === 'SPIXN_WARI_CARD_REGISTRATION_REQUEST') {
			if (data.payload && typeof data.payload.clientSecret === 'string') {
				// mode は iframe 側 (spixn-wari-container.tsx) で /api/spixn-wari/payment-method の
				// status を見て 'register' / 'update' を渡してくる。不正値 / 未指定の fallback は
				// openCardRegistrationModal 内で一元化されているのでここでは validate せず転送する。
				openCardRegistrationModal(data.payload.clientSecret, data.payload.mode);
			} else {
				log('SPIXN_WARI_CARD_REGISTRATION_REQUEST: clientSecret が無効です', { data: data });
				sendToIframe('SPIXN_WARI_CARD_REGISTRATION_CANCELLED');
			}
			return;
		}

		log('未知のメッセージタイプ', { type: data.type });
	}

	// --- モーダルエラーメッセージを表示する ---
	// 複数回呼ばれてもDOMが積み上がらないよう、既存のエラー要素があれば再利用する
	var MODAL_ERROR_ATTR = 'data-spixn-wari-error';
	function showModalError(message) {
		if (!modal) return;
		var errorDiv = modal.querySelector('[' + MODAL_ERROR_ATTR + ']');
		if (!errorDiv) {
			errorDiv = document.createElement('div');
			errorDiv.setAttribute(MODAL_ERROR_ATTR, '');
			// 動的に挿入されるエラーを支援技術へ通知するため live region 化する（カード登録フォームのエラー表示と同じ属性）。
			errorDiv.setAttribute('role', 'alert');
			errorDiv.setAttribute('aria-live', 'assertive');
			errorDiv.setAttribute('aria-atomic', 'true');
			errorDiv.style.cssText = [
				'position: absolute',
				'top: 50%',
				'left: 50%',
				'transform: translate(-50%, -50%)',
				'background: #fff',
				'color: #c0392b',
				'padding: 24px 32px',
				'border-radius: 8px',
				'font-size: 14px',
				'text-align: center',
				'z-index: 10001',
				'display: flex',
				'flex-direction: column',
				'align-items: center',
				'gap: 16px',
			].join(';');
			modal.appendChild(errorDiv);
		}
		// 再呼び出しで子要素が積み上がらないよう、一旦クリアしてから組み立て直す。
		while (errorDiv.firstChild) errorDiv.removeChild(errorDiv.firstChild);
		var messageEl = document.createElement('div');
		messageEl.textContent = message;
		errorDiv.appendChild(messageEl);
		// タイムアウト等の致命エラーからの復帰用。親（ストア）ページをリロードする。
		var reloadButton = document.createElement('button');
		reloadButton.type = 'button';
		reloadButton.textContent = '再読み込み';
		reloadButton.style.cssText = [
			'background: #02BCAC',
			'color: #fff',
			'border: none',
			'border-radius: 8px',
			'padding: 10px 24px',
			'font-size: 14px',
			'font-weight: 600',
			'cursor: pointer',
		].join(';');
		reloadButton.addEventListener('click', function() {
			window.location.reload();
		});
		errorDiv.appendChild(reloadButton);
		// 表示時に主アクション（再読み込み）へフォーカスを移し、キーボード/支援技術から即操作できるようにする。
		try { reloadButton.focus(); } catch (e) { /* focus 不能環境では諦める */ }
	}

	// --- モーダルを開く ---
	// SpinCard 押下から呼ばれる。先に fetchOneTimeCode で OTC を取得してから
	// iframe を挿入することで、READY 受信時に postMessage で即座に code を渡せる。
	// (旧設計は iframe ロード後 READY → fetch だったため、mini-app 起動時に
	// ONE_TIME_CODE 待ちの不確定状態がしばらく続いていた)
	function openModal() {
		if (modal || modalOpenInProgress) return;
		modalOpenInProgress = true;
		log('モーダル: OTC を fetch してから開きます');
		fetchOneTimeCodeWithStatusSync().then(function(result) {
			modalOpenInProgress = false;
			// fetch 中に他経路で modal が開かれていれば何もしない
			if (modal) return;
			pendingOneTimeCodeResult = result;
			renderModal();
		});
	}

	// 実際に DOM を生成してモーダルを表示する。openModal で OTC fetch 完了後に呼ばれる。
	function renderModal() {
		if (modal) return;
		log('モーダルを開きます');

		// オーバーレイ
		modal = document.createElement('div');
		modal.setAttribute('role', 'dialog');
		modal.setAttribute('aria-modal', 'true');
		modal.setAttribute('aria-label', 'スピン即割');
		modal.style.cssText = [
			'position: fixed',
			'top: 0',
			'left: 0',
			'width: 100%',
			'height: 100%',
			'background: rgba(0, 0, 0, 0.6)',
			'z-index: 9999',
			'display: flex',
			'align-items: center',
			'justify-content: center',
		].join(';');

		// コンテナ（初期幅は SignIn 用の 420px。iframe 側からの SPIXN_WARI_VIEW_CHANGE で
		// 表示中の画面に応じて maxWidth を切り替える）
		modalContainer = document.createElement('div');
		modalContainer.style.cssText = [
			'position: relative',
			'background: #fff',
			'border-radius: 24px',
			'overflow: hidden',
			'width: 90%',
			'max-width: 420px',
			'max-height: 90vh',
			'display: flex',
			'flex-direction: column',
			'transition: max-width 0.2s ease',
			// Figma `SignupModal_Start` / `LoginModal_Step_*` の effect (= styles.ts MODAL_BOX_SHADOW)
			'box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08)',
		].join(';');

		// iframe（モーダル内の閉じるボタンは iframe 側のヘッダーで提供する。
		// 親側は backdrop クリックでクローズ可能なため別途 close button は出さない）
		iframe = document.createElement('iframe');
		iframe.src = iframeBaseUrl + IFRAME_PATH;
		iframe.style.cssText = [
			'width: 100%',
			'height: 720px',
			'border: none',
			'display: block',
		].join(';');
		iframe.setAttribute('allow', 'payment');
		iframe.title = 'スピン即割';

		modalContainer.appendChild(iframe);
		modal.appendChild(modalContainer);

		// オーバーレイクリックで閉じる
		modal.addEventListener('click', function(e) {
			if (e.target === modal) {
				closeModal();
			}
		});

		document.body.appendChild(modal);
		document.body.style.overflow = 'hidden';

		// a11y: 開く前のフォーカス位置を保存し、Esc で閉じられるようにする
		modalPreviouslyFocusedElement = document.activeElement;
		modalKeydownHandler = function(e) {
			if (e.key === 'Escape' || e.keyCode === 27) {
				e.stopPropagation();
				closeModal();
			}
		};
		document.addEventListener('keydown', modalKeydownHandler);
		// 初期フォーカスをモーダル本体に移す（iframe 内 UI への明示的な遷移は iframe 側に委ねる）
		modal.tabIndex = -1;
		try { modal.focus(); } catch (e) { /* focus 不能環境では諦める */ }

		// メッセージリスナーを登録
		messageListener = handleMessage;
		window.addEventListener('message', messageListener);

		// ハンドシェイクタイムアウト（10秒）
		handshakeTimer = setTimeout(function() {
			handshakeTimer = null;
			log('ハンドシェイクタイムアウト（10秒）');
			showModalError('読み込みに失敗しました。再度お試しください。');
		}, 10000);
	}

	// --- 金額フォーマット ---
	function formatYen(n) {
		return '¥' + Number(n).toLocaleString('ja-JP');
	}

	// --- App Proxy から one_time_code を取得する ---
	// このファイルは App Proxy 必須版。init() で常に呼ばれる。
	// 戻り値: { status: 'logged_in' | 'no_customer' | 'unknown', code: string | null }
	// - 'logged_in': HTTP 200 + one_time_code 取得 (code は文字列)
	// - 'no_customer': HTTP 200 で one_time_code 無し / HTTP 4xx (= App Proxy が customer 認証を弾いた)
	//   App Proxy は customer 未ログイン時に 400 を返す (`logged_in_customer_id is required`) ため、
	//   400-499 全般を「確定的に未ログイン」として扱う。
	// - 'unknown': HTTP 5xx / network error / json parse error / 5 秒 timeout (fail-secure)
	// 注: backend は GET 毎に one_time_code を upsert するため、timeout 後の遅延レスポンスが
	//     DB 上の code を更新してしまうリスクがある。AbortController で timeout 時に
	//     fetch を中断する。AbortController が無い古いブラウザでは中断は効かないが、
	//     その場合でも fetch の resolved 値は破棄され、関数の戻り値には影響しない。
	function fetchOneTimeCode() {
		var FETCH_TIMEOUT_MS = 5000;
		var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		var timeoutId = null;

		var fetchOptions = { credentials: 'include' };
		if (controller) fetchOptions.signal = controller.signal;

		var fetchPromise = fetch('/apps/spixn/api/customer_code', fetchOptions)
			.then(function(res) {
				if (res.status >= 400 && res.status < 500) {
					return { status: 'no_customer', code: null };
				}
				if (!res.ok) {
					return { status: 'unknown', code: null };
				}
				return res.json().then(function(data) {
					if (data && typeof data.one_time_code === 'string' && data.one_time_code.length > 0) {
						return { status: 'logged_in', code: data.one_time_code };
					}
					return { status: 'no_customer', code: null };
				}).catch(function() {
					return { status: 'unknown', code: null };
				});
			})
			.catch(function() {
				// AbortError (timeout 経由の abort) もここに来る → 'unknown' に流す
				return { status: 'unknown', code: null };
			});

		var timeoutPromise = new Promise(function(resolve) {
			timeoutId = setTimeout(function() {
				if (controller) controller.abort();
				resolve({ status: 'unknown', code: null });
			}, FETCH_TIMEOUT_MS);
		});

		// fetch が先に決着した場合は timeoutId を解除して残留タイマーを残さない。
		return Promise.race([fetchPromise, timeoutPromise]).then(function(result) {
			if (timeoutId !== null) clearTimeout(timeoutId);
			return result;
		});
	}

	// fetchOneTimeCode の薄いラッパー。結果を cachedLoginStatus に反映し、
	// 初期化後 (= prev !== null) に状態が変わったら /cart.js を取り直して SpinCard を再描画する。
	//
	// 動機 (Copilot 指摘): 元実装では cachedLoginStatus が init 時の oneTimeCodePromise 解決で
	// 1 回しか更新されず、openModal / balance iframe / checkout guard など他の経路で
	// fetchOneTimeCode を呼び直しても cachedLoginStatus が stale のままになる。
	// 結果、別タブでログアウト / ログイン or session 切れが起きると SpinCard 分岐や
	// balance iframe 起動条件が実際の状態とズレる。
	function fetchOneTimeCodeWithStatusSync() {
		return fetchOneTimeCode().then(function(result) {
			var prev = cachedLoginStatus;
			cachedLoginStatus = result.status;
			// 初回 (prev = null) は init 側で renderSpinCardForCart を別途呼んでいるためスキップ。
			// 2 回目以降で status が変化したときのみ、最新 cart を取り直して再描画する。
			if (prev !== null && prev !== result.status) {
				log('cachedLoginStatus が変化したため SpinCard を再描画', { prev: prev, next: result.status });
				fetchCartSnapshot().then(function(cart) {
					if (!cart) return;
					var subtotal = parseCartSubtotal(cart);
					if (typeof subtotal === 'number') lastKnownSubtotal = subtotal;
					if (cart.token) lastKnownCartToken = cart.token;
					renderSpinCardForCartGated(cart, subtotal);
				});
			}
			return result;
		});
	}

	// fetchOneTimeCode の結果を iframe へ送信する分岐。READY ハンドラから呼ばれる。
	// 'unknown' (5xx / network / timeout) は iframe に何も送らず mini-app の OTC 待ちのまま放置する。
	function dispatchOneTimeCodeToIframe(result) {
		if (result.status === 'logged_in' && result.code) {
			sendToIframe('SPIXN_WARI_ONE_TIME_CODE', { oneTimeCode: result.code });
			return;
		}
		if (result.status === 'no_customer') {
			sendToIframe('SPIXN_WARI_NO_CUSTOMER');
			return;
		}
		log('one_time_code 取得 unknown 状態、iframe 通知をスキップ');
	}

	// --- サムネ URL のバリデーション ---
	// cart attribute (`spixn_wari_selected_items` 内の imageUrl) はユーザーが任意に
	// 書き換え可能なため、SpinCard_F の <img src> にそのまま流すと外部ドメインへの
	// 任意リクエスト（トラッキング・情報漏えい）を発生させ得る。https のみ許可し、
	// Shopify CDN・同一オリジン・**現在のショップ自身の myshopify.com** のみ allowlist する。
	// `*.myshopify.com` 全許可だと攻撃者管理のストアも通ってしまう。
	function isAllowedThumbUrl(url) {
		if (typeof url !== 'string' || url.length === 0) return false;
		try {
			var u = new URL(url, window.location.origin);
			if (u.protocol !== 'https:') return false;
			if (u.hostname === window.location.hostname) return true;
			if (u.hostname === 'cdn.shopify.com') return true;
			var shop = window.Shopify && typeof window.Shopify.shop === 'string'
				? window.Shopify.shop.toLowerCase()
				: '';
			var currentShopHost = shop
				? shop.replace(/^https?:\/\//, '').replace(/\/.*$/, '')
				: null;
			if (currentShopHost && u.hostname === currentShopHost) return true;
			return false;
		} catch (e) {
			return false;
		}
	}

	// --- SpinCard / SpinCard_F の挿入先を探す ---
	// Dawn テーマには cart notification drawer の `form#cart-notification-form` も存在するため、
	// cart ページ本体の構造に当てはまる優先順で探す。card 要素を実際に挿入し、ラベル文字列を返す。
	function attachSpinCardToDom(card) {
		var candidates = [
			{ selector: '#main-cart-items', label: '#main-cart-items', strategy: 'append' },
			{ selector: 'form#cart', label: 'form#cart', strategy: 'append' },
			{ selector: '.cart__items, .cart-items', label: '.cart__items', strategy: 'append' },
			{ selector: 'table[class*="cart-items"]', label: 'after cart table', strategy: 'after' },
			{ selector: '.cart__ctas', label: 'before .cart__ctas (legacy)', strategy: 'before' },
		];
		for (var i = 0; i < candidates.length; i++) {
			var c = candidates[i];
			var el = document.querySelector(c.selector);
			if (!el) continue;
			if (c.strategy === 'append') {
				el.appendChild(card);
			} else if (c.strategy === 'after' && el.parentNode) {
				el.parentNode.insertBefore(card, el.nextSibling);
			} else if (c.strategy === 'before' && el.parentNode) {
				el.parentNode.insertBefore(card, el);
			} else {
				continue;
			}
			return c.label;
		}
		return null;
	}

	// --- カート全体を取得する ---
	// `/cart.js` を 1 回叩いてレスポンスをそのまま返す。subtotal と attributes 両方を
	// 利用したい init / refresh で共有することで二重 fetch を避ける。
	function fetchCartSnapshot() {
		var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		return fetch(root + 'cart.js', { credentials: 'same-origin' })
			.then(function(res) {
				if (!res.ok) throw new Error('cart.js request failed: ' + res.status);
				return res.json();
			})
			.catch(function(err) {
				log('cart.js の取得に失敗しました', { error: err && err.message });
				return null;
			});
	}

	// --- カート小計（JPY）を抽出する ---
	// Shopify cart.js の金額は JPY でも 1/100 単位で返る（例: ¥9,000 → 900000）。
	// 閾値判定はスピン即割等の割引適用後の値ではなく **割引前** の金額を使う。
	// total_price を見ると SpinCard_F (適用中) で「選択を編集」を開いた瞬間に小計が
	// 閾値未達と判定されて「適用外」UI が出てしまうため、original_total_price を最優先。
	function parseCartSubtotal(cart) {
		if (!cart) return null;
		var subtotalCents;
		if (typeof cart.original_total_price === 'number') {
			subtotalCents = cart.original_total_price;
		} else if (typeof cart.items_subtotal_price === 'number') {
			subtotalCents = cart.items_subtotal_price;
		} else if (typeof cart.total_price === 'number') {
			// 後方互換用フォールバック
			subtotalCents = cart.total_price;
		} else {
			return null;
		}
		return subtotalCents / 100;
	}

	// --- 予約販売(PRE-ORDER)商品の有無を判定する (S1-2657) ---
	// /cart.js の line item には product.tags が無いため、unique な handle ごとに
	// /products/{handle}.js を fetch して tags を確認する。handle 署名で memo 化し、
	// 同一カート構成での再描画 (login status 変化等) で fetch を重複させない。
	// 結果値ではなく「署名 → 進行中 Promise」をキャッシュすることで、判定 fetch の解決前に
	// 複数経路から同一署名で呼ばれても fetch を 1 回に集約する（in-flight 共有）。
	// fetch 失敗時は fail-open（その商品は非 pre-order 扱い = 即割を維持）。
	var preOrderCacheSignature = null;
	var preOrderCachePromise = null;
	function cartHasPreOrderProduct(cart) {
		var handles = [];
		if (cart && Array.isArray(cart.items)) {
			for (var i = 0; i < cart.items.length; i++) {
				var h = cart.items[i] && cart.items[i].handle;
				if (typeof h === 'string' && h && handles.indexOf(h) === -1) handles.push(h);
			}
		}
		var signature = handles.slice().sort().join('|');
		// 同一署名なら進行中 / 解決済みの Promise を共有して返す（重複 fetch 防止）。
		if (signature === preOrderCacheSignature && preOrderCachePromise) return preOrderCachePromise;
		preOrderCacheSignature = signature;
		if (handles.length === 0) {
			preOrderCachePromise = Promise.resolve(false);
			return preOrderCachePromise;
		}
		var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		var want = SPIXN_PREORDER_TAG.toUpperCase();
		preOrderCachePromise = Promise.all(handles.map(function(handle) {
			return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
				.then(function(res) {
					if (!res.ok) throw new Error('products.js returned ' + res.status);
					return res.json();
				})
				.then(function(product) {
					var tags = [];
					if (product && Array.isArray(product.tags)) tags = product.tags;
					else if (product && typeof product.tags === 'string') tags = product.tags.split(',');
					return tags.some(function(t) {
						return typeof t === 'string' && t.trim().toUpperCase() === want;
					});
				})
				.catch(function(err) {
					log('products.js の取得に失敗しました（pre-order 判定は false 扱い）', { handle: handle, error: err && err.message });
					return false;
				});
		})).then(function(results) {
			return results.indexOf(true) !== -1;
		});
		return preOrderCachePromise;
	}

	// --- 適用済み (SpinCard_F) 状態を attributes から復元する ---
	// 戻り値: { discountId, items, totalDiscount, availableBalance } または null
	// discount_id 単独ではなく selected_items も適用検出のシグナルとして見る。
	// 理由: /api/spixn-wari/discount が成功して Shopify の割引コードは applyDiscountCode で
	// カートに反映されたが、DB 側の discount_id 永続化が失敗した（null 返却）ケースでも
	// SpinCard_F を復元できるようにするため。
	function parseAppliedSpinCardState(cart) {
		if (!cart) return null;
		var attrs = cart.attributes || {};
		var discountId = (typeof attrs.spixn_wari_discount_id === 'string' && attrs.spixn_wari_discount_id) || null;
		var items = [];
		if (typeof attrs.spixn_wari_selected_items === 'string') {
			try {
				var parsed = JSON.parse(attrs.spixn_wari_selected_items);
				if (Array.isArray(parsed)) items = parsed;
			} catch (e) { /* parse 失敗時は items 空のまま */ }
		}
		// discount_id か selected_items のいずれかが揃っていれば適用済みとみなす
		if (!discountId && items.length === 0) return null;
		var totalDiscount = Number(attrs.spixn_wari_total_discount);
		if (!isFinite(totalDiscount)) totalDiscount = items.reduce(function(s, i) {
			return s + (Number(i.discountAmount) || 0);
		}, 0);
		var availableBalance = Number(attrs.spixn_wari_available_balance);
		if (!isFinite(availableBalance)) availableBalance = totalDiscount;
		return {
			discountId: discountId,
			items: items,
			totalDiscount: totalDiscount,
			availableBalance: availableBalance,
		};
	}

	// --- 直近のカート小計（親→iframe への INIT/CART_UPDATE 送信時に使い回す） ---
	var lastKnownSubtotal = null;
	// --- 直近のカートトークン（SPIXN_WARI_INIT の cartToken に使う） ---
	var lastKnownCartToken = null;
	// [T1-660] spixncard/shown を送信済みの cart_token。cart 単位で 1 回だけ送るための抑制キー。
	// 正確性は分析側 mart の bool_or が最終保証するため、この抑制はコスト削減（access_log 肥大化防止）目的。
	var spixncardShownSentCartToken = null;
	// --- 直近の適用済みステート（INIT 同送で iframe 側の pre-select に使う） ---
	var lastAppliedState = null;
	// --- 直近のカート item_count（カート減少検知用） ---
	// installCartFetchHook で `/cart/add` `/cart/change` `/cart/clear` `/cart/update`
	// 完了後の最新 item_count と比較し、減少した時だけ resetSpixnWariCartState を発火する。
	// item_count 不変 / 増加では reset しない（バリアント変更・qty +1・新商品追加は許容）。
	// init 直後 / apply 成功後 / reset 後に再計算する。
	var lastKnownItemCount = null;
	// --- reset の同時実行抑止フラグ ---
	// reset POST 中にユーザが追加で数量変更等を行うと hook が再発火し reset POST が
	// 多重に飛ぶ可能性がある（lastKnownItemCount は reset 成功時しか更新しないため
	// item_count 比較では抑止できない）。進行中は追加 reset をスキップして、完了/失敗で解除する。
	var resetInProgress = false;

	// --- SpinCard の進捗・残額表示を更新する ---
	// CTA の disabled は撤廃し、閾値未達でも常にクリック可能（モーダル側で適用可否を制御）。
	function updateSpinCardProgress(subtotal) {
		lastKnownSubtotal = (typeof subtotal === 'number') ? subtotal : null;
		if (!spinCardEls) return;
		if (typeof subtotal !== 'number') return;

		var ratio = Math.min(subtotal / SPIXN_MIN_SUBTOTAL, 1);
		spinCardEls.progressFill.style.width = Math.round(ratio * 100) + '%';

		var reached = subtotal >= SPIXN_MIN_SUBTOTAL;
		var remainingLabel = reached
			? '適用済み'
			: 'あと ' + formatYen(SPIXN_MIN_SUBTOTAL - subtotal) + ' で適用';
		spinCardEls.remainingText.textContent = remainingLabel;

		// a11y: progressbar の現在値と読み上げテキストを更新
		if (spinCardEls.progressTrack) {
			spinCardEls.progressTrack.setAttribute('aria-valuenow', String(Math.min(subtotal, SPIXN_MIN_SUBTOTAL)));
			spinCardEls.progressTrack.setAttribute('aria-valuetext', remainingLabel);
		}
	}

	// --- カート系 fetch 完了後の後処理 ---
	// /cart.js を 1 回だけ叩いて以下をまとめて行う:
	//   1) SpinCard の小計表示を更新
	//   2) iframe（spixn-wari mini-app）を開いていれば SPIXN_WARI_CART_UPDATE を通知
	//   3) item_count が直前観測値より下がっていたら spixn-wari 状態をリセット
	// 3) は SPIXN- discount or spixn_wari_* attribute が残っていて、かつ item_count が
	// 減少したケース（qty -1 / 商品削除 / /cart/clear）で発火する。
	// item_count 不変 (バリアント変更・attribute-only update) や増加 (qty +1 / 新商品追加)
	// では発火しない。
	function handleExternalCartMutation() {
		return fetchCartSnapshot().then(function(cart) {
			if (!cart) return null;
			var subtotal = parseCartSubtotal(cart);
			updateSpinCardProgress(subtotal);
			// iframe を開いている間は最新小計を都度通知する。閾値未達状態の遷移を iframe 側で
			// リアクティブに反映するため。
			if (iframe && iframe.contentWindow) {
				sendToIframe('SPIXN_WARI_CART_UPDATE', { cartSubtotal: subtotal });
			}
			// reset 進行中は何もしない（lastKnownItemCount 更新もスキップして race signal を保持）。
			// reset 成功時 callback で lastKnownItemCount は最新化される。
			if (resetInProgress) return subtotal;

			// [S1-2581] item_count 比較より先に session check を行う。
			// session 切れ + cart に残骸があれば cleanup 走り、戻り値 cleared=true。
			// その場合は item_count 比較を skip する (cleanup が cart 状態を更新するため、
			// ここで item_count 比較しても意味がない)。
			// hook 経由の cart は fresh 取得直後なので追加 fetch 不要 (cleanupIfSessionExpired
			// 内部の resetSpixnWariCartState 呼び出しに cartIsFresh=true が渡る)。
			return cleanupIfSessionExpired(cart).then(function(cleared) {
				if (cleared) return subtotal;

				var newItemCount = (cart && typeof cart.item_count === 'number') ? cart.item_count : null;
				// init 前で baseline 未設定の場合（hook が先に発火する race）はリセット判定を
				// スキップして lastKnownItemCount だけ初期化する。
				if (lastKnownItemCount !== null
					&& newItemCount !== null
					&& newItemCount < lastKnownItemCount
					&& (hasSpixnCodeInCart(cart) || hasSpixnWariAttributes(cart))) {
					log('カート item_count の減少を検知。spixn-wari 状態をリセットします', {
						before: lastKnownItemCount,
						after: newItemCount,
					});
					// hook 経由の cart は直前に fetch したばかりで fresh なので再取得は不要
					resetSpixnWariCartState(cart, true);
					// resetSpixnWariCartState の成功時 callback で lastKnownItemCount を再計算するので
					// ここでは更新しない（古い構成を一時的に保持して race 抑止）。
					return subtotal;
				}
				if (newItemCount !== null) lastKnownItemCount = newItemCount;
				// [S1-2623] cart 操作後に SpinCard 表示状態を最新 cart に同期させる。
				// 別タブで他クーポンが入った / 別タブで SPIXN- が入れ替わった等の乖離を解消。
				// reset 経路（cleared=true / item_count 減少）はそれぞれ renderSpinCardForCart を
				// 内部で呼ぶため、ここに到達した時のみ再描画判定。
				// fingerprint が変化していなければ DOM 再構築を skip (hot path 最適化)。
				// 進捗バーの reactive 更新は冒頭の updateSpinCardProgress(subtotal) で済んでいる。
				// [S1-2657] pre-order 判定を解決してから fingerprint 比較・再描画する。
				// fingerprint に hasPreOrder を含めるため、判定値が必要。
				var seq = ++spinCardRenderSeq;
				return cartHasPreOrderProduct(cart).then(function(hasPreOrder) {
					// より新しい描画要求が来ていれば stale なのでスキップ。
					if (seq !== spinCardRenderSeq) return subtotal;
					var currentFingerprint = computeRenderFingerprint(
						hasNonSpixnDiscountInCart(cart),
						hasSpixnDiscountInCart(cart),
						parseAppliedSpinCardState(cart),
						hasPreOrder
					);
					if (currentFingerprint !== lastRenderedFingerprint) {
						renderSpinCardForCart(cart, subtotal, undefined, hasPreOrder);
					}
					return subtotal;
				});
			});
		});
	}

	// --- SpinCard 用アセットURL ---
	// `spincard_coat.png` は Shopify テーマの assets/ にアップロード済みの前提で参照する。
	// テーマフォルダ番号（t/1, t/2 ...）は環境ごとに変わるため、まずページ内の既存
	// theme assets URL（script/link 由来）から base を抽出し、見つからなければ `t/current` を fallback にする。
	function getShopifyAssetsBaseUrl() {
		var pattern = /\/cdn\/shop\/t\/(?:current|\d+)\/assets\//;
		var nodes = document.querySelectorAll('script[src], link[href]');
		for (var i = 0; i < nodes.length; i++) {
			var url = nodes[i].src || nodes[i].href;
			var match = url && url.match(pattern);
			if (match) return url.substring(0, url.indexOf(match[0]) + match[0].length);
		}
		return null;
	}

	function getCoatImageUrl() {
		var override = window.SpixnWariAssetOverrides && window.SpixnWariAssetOverrides.coatImageUrl;
		if (override) return override;
		var base = getShopifyAssetsBaseUrl();
		if (base) return base + 'spincard_coat.png';
		return window.location.origin + '/cdn/shop/t/current/assets/spincard_coat.png';
	}

	// ヘッダーアイコン SVG（assets/spincard_header_icon.svg と同内容）
	var HEADER_ICON_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
		+ '<rect width="23.9999" height="24" rx="12" fill="white"/>'
		+ '<path d="M15.0759 12.6421C14.8549 12.855 14.6004 13.0942 14.3246 13.3467L15.7065 14.41C16.1769 13.9741 16.5814 13.5788 16.8764 13.2838L16.9626 13.1987C17.1572 13.003 17.3346 12.8266 17.5121 12.6421H15.0759Z" fill="#02BCAC"/>'
		+ '<path d="M16.9325 11.8241C17.522 11.8241 18 11.3462 18 10.7567C18 10.1672 17.522 9.68928 16.9325 9.68928C16.3429 9.68928 15.8649 10.1672 15.8649 10.7567C15.8649 11.3462 16.3429 11.8241 16.9325 11.8241Z" fill="#02BCAC"/>'
		+ '<path d="M13.4237 14.1749H13.4186L12.1199 13.1744L8.66587 10.5388C8.50199 10.3957 8.37162 10.2182 8.28401 10.019C8.19641 9.81984 8.15372 9.60382 8.15896 9.38629C8.18634 8.50642 9.01969 7.81206 10.0112 7.8374C10.5114 7.84618 10.988 8.052 11.3373 8.41012C11.4746 8.55192 11.5821 8.71978 11.6535 8.9038C11.7249 9.08782 11.7587 9.28428 11.7529 9.48158C11.7504 9.57863 11.7374 9.67514 11.7144 9.76946L11.6749 9.8982C11.643 9.98866 11.6026 10.0759 11.5542 10.1587C11.4963 10.2557 11.4283 10.3465 11.3515 10.4294L11.02 10.7994L12.3835 11.8495L12.6339 11.5708C12.7876 11.4002 12.9234 11.2144 13.0395 11.0163C13.146 10.833 13.2346 10.6398 13.3041 10.4395L13.3629 10.2499L13.3761 10.2064C13.5082 9.68422 13.5051 9.137 13.3669 8.61642C13.2287 8.09585 12.96 7.61909 12.5863 7.23122C11.924 6.54007 11.0149 6.13918 10.0578 6.11618H9.95646C8.06671 6.11618 6.50036 7.53532 6.44359 9.32851C6.43149 9.80233 6.52418 10.273 6.71503 10.7068C6.90588 11.1407 7.19018 11.5271 7.54764 11.8384L7.57095 11.8597L12.0571 15.2879C11.0189 15.9883 10.2322 16.1678 9.69996 16.1678C8.93656 16.1678 8.28062 15.8191 7.93592 15.2352C7.79925 15.0107 7.72529 14.7537 7.72172 14.4909C7.71815 14.2281 7.78512 13.9692 7.91565 13.741L7.94809 13.6883L6.58248 12.6402C6.51861 12.7294 6.46083 12.8176 6.41419 12.8987C6.13678 13.3882 5.99393 13.9424 6.00017 14.5051C6.0064 15.0677 6.16149 15.6186 6.44967 16.1019C7.10156 17.2169 8.31509 17.8839 9.69388 17.8839C10.8871 17.8839 12.1554 17.3771 13.4774 16.3776L14.7275 17.3325H17.556L13.4237 14.1749Z" fill="#02BCAC"/>'
		+ '</svg>';

	// [S1-2661] スピン即割の共通注意書き文言（SpinCard_A/C/F で共用。文言変更時の更新漏れ防止）。
	var NOTE_OTHER_ADDRESS_TEXT = 'プレゼントなど、他者の住所への配送をご希望の場合はスピン即割はご利用いただけません';

	// [S1-2665] 予約販売(PRE-ORDER)商品がカートにある場合に注記へ追記する文言。
	var NOTE_PREORDER_TEXT = '予約商品はスピン即割対象外です';

	// [S1-2661] スピン即割の共通注意書き（バー UI 下に表示）。
	// プレゼント等で他者住所へ配送する場合はスピン即割を利用できない旨を SpinCard_A/C/F 全てのバー下に出す。
	// スタイルは SpinCard_A の既存注記（過去注文と同じメールアドレス…）と揃える（12px / #939096）。
	// [S1-2665] hasPreOrder が true の場合は予約商品の注記を改行で同じ <p> に続けて追記する。
	function buildSpinCardOtherAddressNote(hasPreOrder) {
		var note = document.createElement('p');
		note.appendChild(document.createTextNode(NOTE_OTHER_ADDRESS_TEXT));
		if (hasPreOrder) {
			note.appendChild(document.createElement('br'));
			note.appendChild(document.createTextNode(NOTE_PREORDER_TEXT));
		}
		note.style.cssText = [
			'margin: 0',
			'font-weight: 400',
			'font-size: 12px',
			'line-height: 1.44',
			'color: #939096',
		].join(';');
		return note;
	}

	// [S1-2665] 予約販売(PRE-ORDER)商品がある場合に SpinCard の CTA を無効化する。
	// 背景をグレーにし、cursor を not-allowed、disabled / aria-disabled を立てる。
	// click ハンドラ側でも hasPreOrder ガードを併用するため二重に openModal を抑止する。
	function disableSpinCardCta(cta) {
		cta.disabled = true;
		cta.setAttribute('aria-disabled', 'true');
		cta.style.background = '#CCCCCC';
		// 背景がライトグレーになるため、文字色も暗めにしてコントラストを確保する。
		cta.style.color = '#666666';
		cta.style.cursor = 'not-allowed';
	}

	// --- SpinCard を挿入する（Figma `SpinCard_A` node 6240:36380 ベース） ---
	// [S1-2665] hasPreOrder: 予約販売商品がカートにある場合 true。注記追記 + CTA 無効化に使う。
	function insertSpinCard(hasPreOrder) {
		var card = document.createElement('div');
		card.setAttribute('data-spixn-wari-spin-card', '');
		card.setAttribute('role', 'region');
		card.setAttribute('aria-label', 'スピン即割');
		card.className = 'spixn-wari-sc-root';
		card.style.cssText = [
			'box-sizing: border-box',
			'display: flex',
			'align-items: stretch',
			'gap: 20px',
			'width: 100%',
			'padding: 20px',
			'margin: 24px 0',
			'background: #F8F8F9',
			'border-radius: 12px',
			'font-family: "Noto Sans JP", "Hiragino Sans", sans-serif',
		].join(';');

		// 左カラム（情報 + 進捗バー + 注記）
		var leftCol = document.createElement('div');
		leftCol.style.cssText = [
			'flex: 1 1 auto',
			'min-width: 0',
			'display: flex',
			'flex-direction: column',
			'gap: 8px',
		].join(';');

		// 上半分: Header + AmountRow を縦に並べる
		var topBlock = document.createElement('div');
		topBlock.style.cssText = ['display: flex', 'flex-direction: column'].join(';');

		// Header
		var header = document.createElement('div');
		header.style.cssText = ['display: flex', 'align-items: center', 'gap: 4px'].join(';');
		var iconWrap = document.createElement('span');
		iconWrap.style.cssText = [
			'display: inline-flex',
			'align-items: center',
			'justify-content: center',
			'width: 24px',
			'height: 24px',
			'flex-shrink: 0',
		].join(';');
		iconWrap.innerHTML = HEADER_ICON_SVG;
		var titleText = document.createElement('span');
		titleText.textContent = 'スピン即割';
		titleText.style.cssText = [
			'font-weight: 700',
			'font-size: 18px',
			'line-height: 1.45',
			'color: #2B2B2B',
		].join(';');
		header.appendChild(iconWrap);
		header.appendChild(titleText);

		// AmountRow
		var amountRow = document.createElement('div');
		amountRow.style.cssText = [
			'display: flex',
			'justify-content: space-between',
			'align-items: flex-end',
			'gap: 4px',
		].join(';');
		var amountLabel = document.createElement('span');
		amountLabel.textContent = formatYen(SPIXN_MIN_SUBTOTAL) + '以上で適用';
		amountLabel.style.cssText = [
			'font-weight: 400',
			'font-size: 14px',
			'line-height: 1.2',
			'color: #939096',
		].join(';');
		var remainingText = document.createElement('span');
		// 同時に存在する SpinCard は 1 枚 (removeExistingSpinCards で重複除去) なので固定 id でよい。
		remainingText.id = 'spixn-wari-remaining';
		remainingText.textContent = 'あと ' + formatYen(SPIXN_MIN_SUBTOTAL) + ' で適用';
		remainingText.style.cssText = [
			'font-weight: 700',
			'font-size: 16px',
			'line-height: 1.45',
			'color: #02BCAC',
		].join(';');
		amountRow.appendChild(amountLabel);
		amountRow.appendChild(remainingText);

		topBlock.appendChild(header);
		topBlock.appendChild(amountRow);

		// ProgressBar（a11y: progressbar として読み上げ可能にする）
		var progressTrack = document.createElement('div');
		progressTrack.setAttribute('role', 'progressbar');
		progressTrack.setAttribute('aria-valuemin', '0');
		progressTrack.setAttribute('aria-valuemax', String(SPIXN_MIN_SUBTOTAL));
		progressTrack.setAttribute('aria-valuenow', '0');
		progressTrack.setAttribute('aria-valuetext', 'あと ' + formatYen(SPIXN_MIN_SUBTOTAL) + ' で適用');
		progressTrack.style.cssText = [
			'width: 100%',
			'height: 12px',
			'background: #E0E0E1',
			'border-radius: 32px',
			'overflow: hidden',
		].join(';');
		var progressFill = document.createElement('div');
		progressFill.style.cssText = [
			// Shopify テーマの一部が空 div を display:none にするため明示する
			'display: block',
			'width: 0%',
			'height: 100%',
			'background: linear-gradient(90deg, #358DFF 0%, #02BCAC 100%)',
			'border-radius: 32px',
			'transition: width 0.3s ease',
		].join(';');
		progressTrack.appendChild(progressFill);

		// 注記
		var note = document.createElement('p');
		// [S1-2661] 未ログイン (SpinCard_A) は既存注記と同じ要素内に改行で続けて表示する。
		// innerHTML を避け DOM ノードで組み立てる（共通文言は NOTE_OTHER_ADDRESS_TEXT を参照）。
		note.appendChild(document.createTextNode('過去注文と同じメールアドレスでspixnにアカウント登録が必要です。'));
		note.appendChild(document.createElement('br'));
		note.appendChild(document.createTextNode(NOTE_OTHER_ADDRESS_TEXT));
		// [S1-2665] 予約販売商品がある場合は予約商品の注記を改行で続けて追記する。
		if (hasPreOrder) {
			note.appendChild(document.createElement('br'));
			note.appendChild(document.createTextNode(NOTE_PREORDER_TEXT));
		}
		note.style.cssText = [
			'margin: 0',
			'font-weight: 400',
			'font-size: 12px',
			'line-height: 1.44',
			'color: #939096',
		].join(';');

		leftCol.appendChild(topBlock);
		leftCol.appendChild(progressTrack);
		leftCol.appendChild(note);

		// 右カラム（白パネル: 画像 + 文言 + CTA）
		var rightPanel = document.createElement('div');
		rightPanel.className = 'spixn-wari-sc-right';
		rightPanel.style.cssText = [
			'display: flex',
			'align-items: center',
			'gap: 20px',
			'padding: 12px 20px',
			'background: #FFFFFF',
			'border-radius: 12px',
			'flex-shrink: 0',
		].join(';');

		// 画像 + 文言（CTAの左側にまとめて並べる）
		var previewRow = document.createElement('div');
		previewRow.style.cssText = ['display: flex', 'align-items: center', 'gap: 16px'].join(';');
		var coatImage = document.createElement('img');
		coatImage.alt = '';
		coatImage.src = getCoatImageUrl();
		coatImage.style.cssText = [
			'width: 68px',
			'height: 68px',
			'object-fit: cover',
			'border-radius: 8px',
			'flex-shrink: 0',
			'background: #F2F2F2',
		].join(';');
		var tradeInText = document.createElement('p');
		tradeInText.innerHTML = '過去に購入した対象アイテムで<br>下取り金額分お得に！';
		tradeInText.className = 'spixn-wari-sc-tradein';
		tradeInText.style.cssText = [
			'margin: 0',
			'font-weight: 700',
			'font-size: 14px',
			'line-height: 1.714',
			'color: #2B2B2B',
		].join(';');
		previewRow.appendChild(coatImage);
		previewRow.appendChild(tradeInText);

		// CTA（常時クリック可能。閾値未達時はモーダル側で適用不可を表示する）
		var cta = document.createElement('button');
		cta.type = 'button';
		cta.textContent = 'スピン即割を利用';
		cta.className = 'spixn-wari-sc-cta';
		// 残額テキストを aria-describedby で紐付け、SR で適用条件を読める
		cta.setAttribute('aria-describedby', 'spixn-wari-remaining');
		cta.style.cssText = [
			'display: inline-flex',
			'align-items: center',
			'justify-content: center',
			'border: none',
			'border-radius: 12px',
			'padding: 16px 24px',
			'font-family: inherit',
			'font-weight: 700',
			'font-size: 16px',
			'line-height: 1.45',
			'color: #FFFFFF',
			'background: linear-gradient(90deg, #358DFF 0%, #02BCAC 100%)',
			'cursor: pointer',
			'white-space: nowrap',
		].join(';');
		// [S1-2665] 予約販売商品がある場合は CTA を無効化し openModal を抑止する。
		if (hasPreOrder) {
			disableSpinCardCta(cta);
		}
		cta.addEventListener('click', function() {
			if (hasPreOrder) return;
			openModal();
		});

		rightPanel.appendChild(previewRow);
		rightPanel.appendChild(cta);

		card.appendChild(leftCol);
		card.appendChild(rightPanel);

		var insertionTarget = attachSpinCardToDom(card);
		if (insertionTarget) {
			log('SpinCardを挿入しました', { target: insertionTarget });
		} else {
			log('SpinCardの挿入先が見つかりませんでした');
			return;
		}

		spinCardEls = {
			progressFill: progressFill,
			progressTrack: progressTrack,
			remainingText: remainingText,
			cta: cta,
		};
		// 初期描画は呼び出し側 (init) が updateSpinCardProgress を流し込む。
		// ここで handleExternalCartMutation を呼ぶと /cart.js を 2 回 fetch することになるため呼ばない。
	}

	// Dawn テーマの <quantity-input> は click を捕まえて /cart/change や /cart/update を
	// Ajax で叩く。MutationObserver で早期の DOM 変化を拾うと /cart.js がまだ古い値を
	// 返すため、window.fetch をラップして Shopify の cart 系エンドポイントのレスポンス
	// 完了後に handleExternalCartMutation を呼ぶ。
	// 適用中 (SpinCard_F) でも「選択を編集」モーダル中の小計追随に必要なのと、商品変更時の
	// spixn-wari 状態リセット（fingerprint 比較）も同関数内で行うため、init() から
	// (描画するカード種別に依存せず) 毎回呼ぶ。
	function installCartFetchHook() {
		var originalFetch = window.fetch;
		if (typeof originalFetch !== 'function' || window.__spixnWariFetchPatched) return;
		window.__spixnWariFetchPatched = true;
		window.fetch = function() {
			var args = arguments;
			var input = args[0];
			var url = '';
			if (typeof input === 'string') {
				url = input;
			} else if (input && typeof input.url === 'string') {
				url = input.url;
			}
			var isCartMutation = url.indexOf('/cart/change') !== -1
				|| url.indexOf('/cart/update') !== -1
				|| url.indexOf('/cart/add') !== -1
				|| url.indexOf('/cart/clear') !== -1;
			// applyDiscountCode / resetSpixnWariCartState の `?sections=...` 経由 POST は同レスポンスで
			// cart 全体を受け取って状態反映まで済ませるため、ここで /cart.js を再取得しても無駄。
			// fingerprint も呼び出し側で更新済みなので、ここで再判定するとループ発火する恐れもある。
			var isSelfTriggeredApply = url.indexOf('/cart/update.js?sections=') !== -1;
			var promise = originalFetch.apply(this, args);
			if (isCartMutation && !isSelfTriggeredApply) {
				promise.then(function() {
					// レスポンス後すぐに /cart.js を叩くと稀に旧値が返るため
					// 1 フレーム挟んでから再取得する
					setTimeout(handleExternalCartMutation, 50);
				}).catch(function(err) {
					log('cart 系 fetch のラップ中にエラーを検知しました', { error: err && err.message });
				});
			}
			return promise;
		};
	}

	// --- SpinCard_F: 適用済み (スピン即割適用中) のカードを描画する ---
	// state: fetchAppliedSpinCardState の返り値
	// [S1-2665] hasPreOrder: 予約販売商品がカートにある場合 true。注記追記 + CTA 無効化に使う。
	function insertAppliedSpinCard(state, hasPreOrder) {
		var card = document.createElement('div');
		card.setAttribute('data-spixn-wari-spin-card', 'applied');
		card.setAttribute('role', 'region');
		card.setAttribute('aria-label', 'スピン即割適用中');
		card.className = 'spixn-wari-sc-root';
		card.style.cssText = [
			'box-sizing: border-box',
			'display: flex',
			'align-items: stretch',
			'gap: 20px',
			'width: 100%',
			'padding: 20px',
			'margin: 24px 0',
			'background: #F8F8F9',
			'border-radius: 12px',
			'font-family: "Noto Sans JP", "Hiragino Sans", sans-serif',
		].join(';');

		// 左カラム（ヘッダのみ: アイコン + 「スピン即割適用中」）
		var leftCol = document.createElement('div');
		leftCol.style.cssText = [
			'flex: 1 1 auto',
			'min-width: 0',
			'display: flex',
			'flex-direction: column',
			'gap: 8px',
			'justify-content: center',
		].join(';');
		var header = document.createElement('div');
		header.style.cssText = ['display: flex', 'align-items: center', 'gap: 4px'].join(';');
		var iconWrap = document.createElement('span');
		iconWrap.style.cssText = [
			'display: inline-flex',
			'align-items: center',
			'justify-content: center',
			'width: 24px',
			'height: 24px',
			'flex-shrink: 0',
		].join(';');
		iconWrap.innerHTML = HEADER_ICON_SVG;
		var titleText = document.createElement('span');
		// desktop: 「スピン即割適用中」/ mobile: 「スピン即割」(=「適用中」のサフィックスを隠す)
		// Figma の mobile (7533:12087) は header が「スピン即割」のみ + font-size 18px。
		titleText.className = 'spixn-wari-sc-applied-title';
		titleText.appendChild(document.createTextNode('スピン即割'));
		var titleSuffix = document.createElement('span');
		titleSuffix.className = 'spixn-wari-sc-title-suffix';
		titleSuffix.textContent = '適用中';
		titleText.appendChild(titleSuffix);
		titleText.style.cssText = [
			'font-weight: 700',
			'font-size: 16px',
			'line-height: 1.45',
			'color: #2B2B2B',
		].join(';');
		header.appendChild(iconWrap);
		header.appendChild(titleText);
		leftCol.appendChild(header);

		// [mobile] AmountRow + ProgressBar (Figma 7533:12087 では適用中カードにも進捗が出る)。
		// desktop は display:none のまま。.spixn-wari-sc-mobile-flex / -block の @media で表示切替。
		var amountRow = document.createElement('div');
		amountRow.className = 'spixn-wari-sc-mobile-flex';
		amountRow.style.cssText = [
			'display: none',
			'justify-content: space-between',
			'align-items: flex-end',
			'gap: 4px',
		].join(';');
		var amountLabel = document.createElement('span');
		amountLabel.textContent = formatYen(SPIXN_MIN_SUBTOTAL) + '以上で適用';
		amountLabel.style.cssText = [
			'font-weight: 400',
			'font-size: 14px',
			'line-height: 1.2',
			'color: #939096',
		].join(';');
		var remainingText = document.createElement('span');
		remainingText.textContent = '適用済み';
		remainingText.style.cssText = [
			'font-weight: 700',
			'font-size: 16px',
			'line-height: 1.45',
			'color: #02BCAC',
		].join(';');
		amountRow.appendChild(amountLabel);
		amountRow.appendChild(remainingText);
		leftCol.appendChild(amountRow);

		var progressTrack = document.createElement('div');
		progressTrack.className = 'spixn-wari-sc-mobile-block';
		progressTrack.setAttribute('role', 'progressbar');
		progressTrack.setAttribute('aria-valuemin', '0');
		progressTrack.setAttribute('aria-valuemax', String(SPIXN_MIN_SUBTOTAL));
		progressTrack.setAttribute('aria-valuenow', String(SPIXN_MIN_SUBTOTAL));
		progressTrack.setAttribute('aria-valuetext', '適用済み');
		progressTrack.style.cssText = [
			'display: none',
			'width: 100%',
			'height: 12px',
			'background: #E0E0E1',
			'border-radius: 32px',
			'overflow: hidden',
		].join(';');
		var progressFill = document.createElement('div');
		progressFill.style.cssText = [
			'display: block',
			// 適用中 = 進捗 100% (subtotal は閾値以上の前提)
			'width: 100%',
			'height: 100%',
			'background: linear-gradient(90deg, #358DFF 0%, #02BCAC 100%)',
			'border-radius: 32px',
		].join(';');
		progressTrack.appendChild(progressFill);
		leftCol.appendChild(progressTrack);
		// [S1-2661] バー下の注意書き。desktop は bar 非表示のため header 下に出る。
		leftCol.appendChild(buildSpinCardOtherAddressNote(hasPreOrder));

		// 右パネル（白bg, radius 12, padding 12 20, gap 20）: サムネ + 区切り線 + 金額 + CTA
		var rightPanel = document.createElement('div');
		rightPanel.className = 'spixn-wari-sc-right';
		rightPanel.style.cssText = [
			'display: flex',
			'align-items: center',
			'gap: 20px',
			'padding: 12px 20px',
			'background: #FFFFFF',
			'border-radius: 12px',
			'flex-shrink: 0',
		].join(';');

		// サムネイル列（最大3件 + Figma同様 4px gap, 55x55）
		var thumbsRow = document.createElement('div');
		thumbsRow.className = 'spixn-wari-sc-thumbs';
		thumbsRow.style.cssText = ['display: flex', 'flex-wrap: wrap', 'gap: 4px'].join(';');
		var thumbItems = (state.items || []).slice(0, 3);
		for (var ti = 0; ti < thumbItems.length; ti++) {
			var it = thumbItems[ti];
			var safeUrl = it && isAllowedThumbUrl(it.imageUrl) ? it.imageUrl : '';
			if (safeUrl) {
				var img = document.createElement('img');
				img.alt = '';
				img.src = safeUrl;
				img.style.cssText = [
					'width: 55px',
					'height: 55px',
					'object-fit: cover',
					'border-radius: 4px',
					'flex-shrink: 0',
					'background: #EEEEEF',
				].join(';');
				thumbsRow.appendChild(img);
			} else {
				var ph = document.createElement('div');
				ph.style.cssText = [
					'width: 55px',
					'height: 55px',
					'border-radius: 4px',
					'background: #EEEEEF',
				].join(';');
				thumbsRow.appendChild(ph);
			}
		}

		// 区切り線（縦線、Figma の Line 2: stroke #EEEEEF 1px）
		var divider = document.createElement('div');
		divider.setAttribute('aria-hidden', 'true');
		divider.className = 'spixn-wari-sc-divider';
		divider.style.cssText = ['width: 1px', 'align-self: stretch', 'background: #EEEEEF'].join(';');

		// 金額ブロック
		var amountBlock = document.createElement('div');
		amountBlock.className = 'spixn-wari-sc-amount-block';
		amountBlock.style.cssText = ['display: flex', 'flex-direction: column', 'gap: 8px'].join(';');
		var totalRow = document.createElement('div');
		totalRow.style.cssText = ['display: flex', 'align-items: flex-end', 'gap: 12px'].join(';');
		var totalLabel = document.createElement('span');
		totalLabel.textContent = '割引合計金額';
		totalLabel.style.cssText = [
			'font-weight: 600',
			'font-size: 16px',
			'line-height: 1.5',
			'color: #2B2B2B',
		].join(';');
		var totalAmount = document.createElement('span');
		totalAmount.textContent = formatYen(state.totalDiscount);
		totalAmount.style.cssText = [
			'font-weight: 700',
			'font-size: 24px',
			'line-height: 1',
			'color: #02BCAC',
		].join(';');
		totalRow.appendChild(totalLabel);
		totalRow.appendChild(totalAmount);
		var balanceText = document.createElement('span');
		balanceText.textContent = '下取り可能残高：' + formatYen(state.availableBalance);
		balanceText.className = 'spixn-wari-sc-balance';
		balanceText.style.cssText = [
			'font-weight: 400',
			'font-size: 14px',
			'line-height: 1.2',
			'color: #939096',
		].join(';');
		amountBlock.appendChild(totalRow);
		amountBlock.appendChild(balanceText);

		// CTA「選択を編集」 (黒背景 + 件数バッジ)
		var ctaWrap = document.createElement('div');
		ctaWrap.className = 'spixn-wari-sc-cta-wrap';
		ctaWrap.style.cssText = ['position: relative', 'flex-shrink: 0'].join(';');
		var cta = document.createElement('button');
		cta.type = 'button';
		cta.textContent = '選択を編集';
		cta.className = 'spixn-wari-sc-cta';
		cta.style.cssText = [
			'display: inline-flex',
			'align-items: center',
			'justify-content: center',
			'border: none',
			'border-radius: 12px',
			'padding: 16px 24px',
			'font-family: inherit',
			'font-weight: 600',
			'font-size: 16px',
			'line-height: 1.45',
			'color: #FFFFFF',
			'background: #2B2B2B',
			'cursor: pointer',
			'white-space: nowrap',
		].join(';');
		// [S1-2665] 予約販売商品がある場合は CTA を無効化し openModal を抑止する。
		if (hasPreOrder) {
			disableSpinCardCta(cta);
		}
		cta.addEventListener('click', function() {
			if (hasPreOrder) return;
			openModal();
		});
		// バッジ（Figma Label: 32x32 round teal、選択件数）
		var badge = document.createElement('span');
		badge.setAttribute('aria-label', (state.items || []).length + 'アイテム選択中');
		badge.textContent = String((state.items || []).length);
		badge.style.cssText = [
			'position: absolute',
			'top: -10px',
			'right: -10px',
			'min-width: 32px',
			'height: 32px',
			'border-radius: 64px',
			'padding: 0 10px',
			'background: #02BCAC',
			'color: #FFFFFF',
			'font-weight: 900',
			'font-size: 16px',
			'line-height: 32px',
			'text-align: center',
			'box-sizing: border-box',
		].join(';');
		ctaWrap.appendChild(cta);
		ctaWrap.appendChild(badge);

		rightPanel.appendChild(thumbsRow);
		rightPanel.appendChild(divider);
		rightPanel.appendChild(amountBlock);
		rightPanel.appendChild(ctaWrap);

		card.appendChild(leftCol);
		card.appendChild(rightPanel);

		var insertionTarget = attachSpinCardToDom(card);
		if (insertionTarget) {
			log('SpinCard_F (適用中) を挿入しました', { target: insertionTarget });
		} else {
			log('SpinCard_F の挿入先が見つかりませんでした');
		}
		// SpinCard_F でも残高を live 更新できるようにする。
		// 初期は cart attribute スナップショットを表示し、BalanceFetcher が返したら上書きする。
		// 取得失敗 (null) 時は listener 側でスナップショットを残す挙動。
		spinCardBalanceTextEl = balanceText;
	}

	// --- SpinCard_C (ログイン後・未適用) を挿入 ---
	// SpinCard_A との違い:
	//   - 注記「過去注文と同じメールアドレスで…」を出さない (既にログイン済のため)
	//   - 右パネルは trade-in 画像 + 文言の代わりに「割引合計金額: -」「下取り可能残高: ¥X」
	//   - CTA テキストは「スピン即割を利用」ではなく「アイテムを確認」(挙動は openModal で同じ)
	// balance が null のときは「-」を表示し、hidden iframe からの値受信時に in-place で書き換える。
	// [S1-2665] hasPreOrder: 予約販売商品がカートにある場合 true。注記追記 + CTA 無効化に使う。
	function insertSpinCardLoggedInEmpty(balance, hasPreOrder) {
		var card = document.createElement('div');
		card.setAttribute('data-spixn-wari-spin-card', 'logged-in-empty');
		card.setAttribute('role', 'region');
		card.setAttribute('aria-label', 'スピン即割');
		card.className = 'spixn-wari-sc-root';
		card.style.cssText = [
			'box-sizing: border-box',
			'display: flex',
			'align-items: stretch',
			'gap: 20px',
			'width: 100%',
			'padding: 20px',
			'margin: 24px 0',
			'background: #F8F8F9',
			'border-radius: 12px',
			'font-family: "Noto Sans JP", "Hiragino Sans", sans-serif',
		].join(';');

		// 左カラム (Header + AmountRow + ProgressBar、注記なし)
		var leftCol = document.createElement('div');
		leftCol.style.cssText = [
			'flex: 1 1 auto',
			'min-width: 0',
			'display: flex',
			'flex-direction: column',
			'gap: 8px',
		].join(';');

		var topBlock = document.createElement('div');
		topBlock.style.cssText = ['display: flex', 'flex-direction: column'].join(';');

		// Header
		var header = document.createElement('div');
		header.style.cssText = ['display: flex', 'align-items: center', 'gap: 4px'].join(';');
		var iconWrap = document.createElement('span');
		iconWrap.style.cssText = [
			'display: inline-flex',
			'align-items: center',
			'justify-content: center',
			'width: 24px',
			'height: 24px',
			'flex-shrink: 0',
		].join(';');
		iconWrap.innerHTML = HEADER_ICON_SVG;
		var titleText = document.createElement('span');
		titleText.textContent = 'スピン即割';
		titleText.style.cssText = [
			'font-weight: 700',
			'font-size: 18px',
			'line-height: 1.45',
			'color: #2B2B2B',
		].join(';');
		header.appendChild(iconWrap);
		header.appendChild(titleText);

		// AmountRow
		var amountRow = document.createElement('div');
		amountRow.style.cssText = [
			'display: flex',
			'justify-content: space-between',
			'align-items: flex-end',
			'gap: 4px',
		].join(';');
		var amountLabel = document.createElement('span');
		amountLabel.textContent = formatYen(SPIXN_MIN_SUBTOTAL) + '以上で適用';
		amountLabel.style.cssText = [
			'font-weight: 400',
			'font-size: 14px',
			'line-height: 1.2',
			'color: #939096',
		].join(';');
		var remainingText = document.createElement('span');
		// 同時に存在する SpinCard は 1 枚 (removeExistingSpinCards で重複除去) なので固定 id でよい。
		remainingText.id = 'spixn-wari-remaining';
		remainingText.textContent = 'あと ' + formatYen(SPIXN_MIN_SUBTOTAL) + ' で適用';
		remainingText.style.cssText = [
			'font-weight: 700',
			'font-size: 16px',
			'line-height: 1.45',
			'color: #02BCAC',
		].join(';');
		amountRow.appendChild(amountLabel);
		amountRow.appendChild(remainingText);

		topBlock.appendChild(header);
		topBlock.appendChild(amountRow);

		// ProgressBar
		var progressTrack = document.createElement('div');
		progressTrack.setAttribute('role', 'progressbar');
		progressTrack.setAttribute('aria-valuemin', '0');
		progressTrack.setAttribute('aria-valuemax', String(SPIXN_MIN_SUBTOTAL));
		progressTrack.setAttribute('aria-valuenow', '0');
		progressTrack.setAttribute('aria-valuetext', 'あと ' + formatYen(SPIXN_MIN_SUBTOTAL) + ' で適用');
		progressTrack.style.cssText = [
			'width: 100%',
			'height: 12px',
			'background: #E0E0E1',
			'border-radius: 32px',
			'overflow: hidden',
		].join(';');
		var progressFill = document.createElement('div');
		progressFill.style.cssText = [
			'display: block',
			'width: 0%',
			'height: 100%',
			'background: linear-gradient(90deg, #358DFF 0%, #02BCAC 100%)',
			'border-radius: 32px',
			'transition: width 0.3s ease',
		].join(';');
		progressTrack.appendChild(progressFill);

		leftCol.appendChild(topBlock);
		leftCol.appendChild(progressTrack);
		leftCol.appendChild(buildSpinCardOtherAddressNote(hasPreOrder));

		// 右パネル (amountBlock + CTA)
		var rightPanel = document.createElement('div');
		rightPanel.className = 'spixn-wari-sc-right';
		rightPanel.style.cssText = [
			'display: flex',
			'align-items: center',
			'gap: 20px',
			'padding: 12px 20px',
			'background: #FFFFFF',
			'border-radius: 12px',
			'flex-shrink: 0',
		].join(';');

		var amountBlock = document.createElement('div');
		amountBlock.className = 'spixn-wari-sc-amount-block';
		amountBlock.style.cssText = ['display: flex', 'flex-direction: column', 'gap: 8px'].join(';');

		var totalRow = document.createElement('div');
		totalRow.style.cssText = ['display: flex', 'align-items: flex-end', 'gap: 12px'].join(';');
		var totalLabel = document.createElement('span');
		totalLabel.textContent = '割引合計金額';
		totalLabel.style.cssText = [
			'font-weight: 600',
			'font-size: 16px',
			'line-height: 1.5',
			'color: #2B2B2B',
		].join(';');
		var totalAmount = document.createElement('span');
		// 未選択状態のため必ず「-」を出す (SpinCard_F は確定金額、SpinCard_C は未選択 = 「-」)
		totalAmount.textContent = '-';
		totalAmount.style.cssText = [
			'font-weight: 700',
			'font-size: 24px',
			'line-height: 1',
			'color: #02BCAC',
		].join(';');
		totalRow.appendChild(totalLabel);
		totalRow.appendChild(totalAmount);

		var balanceText = document.createElement('span');
		// balance が null = 取得中。値が来たら textContent を書き換える。
		balanceText.textContent = '下取り可能残高：' + (typeof balance === 'number' ? formatYen(balance) : '-');
		balanceText.className = 'spixn-wari-sc-balance';
		balanceText.style.cssText = [
			'font-weight: 400',
			'font-size: 14px',
			'line-height: 1.2',
			'color: #939096',
		].join(';');
		amountBlock.appendChild(totalRow);
		amountBlock.appendChild(balanceText);

		// CTA (黒背景、テキスト「アイテムを確認」)
		var cta = document.createElement('button');
		cta.type = 'button';
		cta.textContent = 'アイテムを確認';
		cta.setAttribute('aria-describedby', 'spixn-wari-remaining');
		cta.className = 'spixn-wari-sc-cta';
		cta.style.cssText = [
			'display: inline-flex',
			'align-items: center',
			'justify-content: center',
			'border: none',
			'border-radius: 12px',
			'padding: 16px 24px',
			'font-family: inherit',
			'font-weight: 600',
			'font-size: 16px',
			'line-height: 1.45',
			'color: #FFFFFF',
			'background: #2B2B2B',
			'cursor: pointer',
			'white-space: nowrap',
		].join(';');
		// [S1-2665] 予約販売商品がある場合は CTA を無効化し openModal を抑止する。
		if (hasPreOrder) {
			disableSpinCardCta(cta);
		}
		cta.addEventListener('click', function() {
			if (hasPreOrder) return;
			openModal();
		});

		rightPanel.appendChild(amountBlock);
		rightPanel.appendChild(cta);

		card.appendChild(leftCol);
		card.appendChild(rightPanel);

		var insertionTarget = attachSpinCardToDom(card);
		if (insertionTarget) {
			log('SpinCard_C (ログイン後・未適用) を挿入しました', { target: insertionTarget });
		} else {
			log('SpinCard_C の挿入先が見つかりませんでした');
			return;
		}

		spinCardEls = {
			progressFill: progressFill,
			progressTrack: progressTrack,
			remainingText: remainingText,
			cta: cta,
		};
		spinCardBalanceTextEl = balanceText;
	}

	// --- 残高取得用 hidden iframe を起動する ---
	// SpinCard_C / SpinCard_F 描画中に呼ぶ。一度作ったら同 key (excludingDiscountId) は再利用、
	// key が変わったら iframe を作り直して再取得する。
	// iframe 側 (BalanceFetcher) が READY → OTC 交換 → orders → 合計算出 → postMessage で返す。
	//
	// excludingDiscountId (省略可):
	//   - SpinCard_C (適用なし) で呼ぶときは省略 / null
	//   - SpinCard_F (適用済) で呼ぶときは適用 discount の id を渡す
	//     (= eligible 集計から自身を除外しない = modal の edit-mode と同じ集計)
	// SpinCard 描画直後に呼ぶ。cachedAvailableBalance が同 key で取得済みなら、スナップショット
	// 初期表示のかわりに live 値を即時反映する (BalanceFetcher の round trip を待たない)。
	function applyCachedBalanceIfFresh(key) {
		var normalizedKey = key || '';
		if (cachedAvailableBalanceForKey !== normalizedKey) return;
		if (typeof cachedAvailableBalance !== 'number') return;
		if (!spinCardBalanceTextEl) return;
		spinCardBalanceTextEl.textContent = '下取り可能残高：' + formatYen(cachedAvailableBalance);
	}

	// hidden balance iframe / listener / cache を完全に破棄する。
	// 呼び元: key 変更時、SpinCard を描画しない分岐 (hasNonSpixn / SpinCard_A)、
	// 取得失敗 (null balance) 受信時 (次回 render で確実に再試行させる)。
	function teardownBalanceIframe() {
		if (balanceIframeMessageListener) {
			window.removeEventListener('message', balanceIframeMessageListener);
			balanceIframeMessageListener = null;
		}
		if (balanceIframe) {
			if (balanceIframe.parentNode) balanceIframe.parentNode.removeChild(balanceIframe);
			balanceIframe = null;
		}
		balanceIframeInited = false;
		cachedAvailableBalance = null;
		cachedAvailableBalanceForKey = '';
	}

	function ensureBalanceIframe(excludingDiscountId) {
		var key = excludingDiscountId || '';
		if (cachedAvailableBalanceForKey === key) {
			// key が同じならキャッシュ or 起動済を再利用
			if (cachedAvailableBalance !== null) return; // 既に取得済
			if (balanceIframe) return; // 起動中
		} else {
			teardownBalanceIframe();
		}
		if (!iframeBaseUrl) return;
		cachedAvailableBalanceForKey = key;

		balanceIframe = document.createElement('iframe');
		balanceIframe.src = iframeBaseUrl + BALANCE_IFRAME_PATH;
		balanceIframe.setAttribute('aria-hidden', 'true');
		balanceIframe.setAttribute('tabindex', '-1');
		balanceIframe.title = 'スピン即割 残高取得';
		balanceIframe.style.cssText = [
			'position: absolute',
			'width: 0',
			'height: 0',
			'border: 0',
			'visibility: hidden',
			'pointer-events: none',
		].join(';');
		document.body.appendChild(balanceIframe);

		balanceIframeMessageListener = function(event) {
			if (event.origin !== iframeBaseUrl) return;
			if (!balanceIframe || event.source !== balanceIframe.contentWindow) return;
			var data = event.data;
			if (!data || typeof data.type !== 'string' || !data.type.startsWith('SPIXN_WARI_')) return;

			if (data.type === 'SPIXN_WARI_READY') {
				if (balanceIframeInited) return;
				balanceIframeInited = true;
				// modal iframe と同じ shape の INIT を送る (BalanceFetcher は spShopId/origin/editingDiscountId
				// を参照)。modal iframe と独立した OTC を fetch する。backend は 1 customer 複数 OTC 許可。
				// editingDiscountId は BalanceFetcher 側で API の excluding_discount_id に転送される。
				balanceIframe.contentWindow.postMessage({
					type: 'SPIXN_WARI_INIT',
					payload: {
						spShopId: spShopId,
						origin: window.location.origin,
						cartSubtotal: lastKnownSubtotal,
						authWithAppProxy: true,
						editingDiscountId: excludingDiscountId || null,
						cartToken: lastKnownCartToken,
					},
				}, iframeBaseUrl);
				fetchOneTimeCodeWithStatusSync().then(function(result) {
					if (!balanceIframe || !balanceIframe.contentWindow) return;
					if (result.status === 'logged_in' && result.code) {
						balanceIframe.contentWindow.postMessage({
							type: 'SPIXN_WARI_ONE_TIME_CODE',
							payload: { oneTimeCode: result.code },
						}, iframeBaseUrl);
					} else if (result.status === 'no_customer') {
						balanceIframe.contentWindow.postMessage({
							type: 'SPIXN_WARI_NO_CUSTOMER',
						}, iframeBaseUrl);
					}
					// 'unknown' は何も送らない (BalanceFetcher 側で何もせず終わる)
				});
				return;
			}

			if (data.type === 'SPIXN_WARI_AVAILABLE_BALANCE') {
				var payload = data.payload || {};
				var balance = (typeof payload.availableBalance === 'number')
					? payload.availableBalance
					: null;
				log('balance iframe から残高を受信しました', { balance: balance, key: key });
				if (typeof balance === 'number') {
					cachedAvailableBalance = balance;
					if (spinCardBalanceTextEl) {
						spinCardBalanceTextEl.textContent = '下取り可能残高：' + formatYen(balance);
					}
				} else {
					// 取得失敗時は iframe を破棄して次回 render で再試行可能にする。
					// textContent は上書きしない (SpinCard_C は "-"、SpinCard_F はスナップショットを維持)。
					teardownBalanceIframe();
				}
				return;
			}
		};
		window.addEventListener('message', balanceIframeMessageListener);
	}

	// --- cart.discount_codes に有効な SPIXN- コードが残っているか判定する（描画用） ---
	// Shopify は cart 金額が下限割れ等で discount を invalid 判定したとき `applicable: false`
	// を返す（cart 上は code が残ったまま）。SpinCard「適用中」表示は実際に効いている
	// コード前提なので `applicable !== false` を必須条件に含める。
	// 用途: renderSpinCardForCart の「適用中」分岐判定、handleCheckoutSubmit の session
	// check トリガ判定など、実効性のあるコードのみ対象としたい場面で使う。
	function hasSpixnDiscountInCart(cart) {
		if (!cart) return false;
		if (!Array.isArray(cart.discount_codes)) return false;
		return cart.discount_codes.some(function(d) {
			if (!d || typeof d.code !== 'string') return false;
			if (d.applicable === false) return false;
			return d.code.indexOf(SPIXN_CODE_PREFIX) === 0;
		});
	}

	// --- cart.discount_codes に SPIXN- 形式の code が残っているか判定する（cleanup 用） ---
	// hasSpixnDiscountInCart と違い `applicable` は問わない。invalid（applicable=false）の
	// SPIXN- も cart に持続している残骸として扱うべきため、cleanupIfSessionExpired の
	// residue 判定や resetSpixnWariCartState の `discount: ''` 送信判定で使う。
	// これを描画分岐に使うと「inert なコードを根拠に適用中表示」を招くので、用途を分けている。
	function hasSpixnCodeInCart(cart) {
		if (!cart) return false;
		if (!Array.isArray(cart.discount_codes)) return false;
		return cart.discount_codes.some(function(d) {
			return d && typeof d.code === 'string' && d.code.indexOf(SPIXN_CODE_PREFIX) === 0;
		});
	}

	// --- cart.attributes に spixn_wari_* が残っているか判定する ---
	function hasSpixnWariAttributes(cart) {
		if (!cart || !cart.attributes) return false;
		var a = cart.attributes;
		return !!(a.spixn_wari_discount_id
			|| a.spixn_wari_selected_items
			|| a.spixn_wari_total_discount
			|| a.spixn_wari_available_balance);
	}

	// --- [S1-2623] cart に SPIXN- 以外の有効な discount コードがあるか判定する ---
	// スピン即割は他クーポンと併用不可。Shopify の combinability ルール上、別クーポンが
	// 先に入っていると SPIXN- 発行時に auto-strip されるため、storefront 側でも明示的に
	// 「他クーポン適用済」状態を検知して SpinCard セクション自体を非表示にする。
	// `applicable: false`（無効/失効）コードは除外して false-positive を防ぐ。
	function hasNonSpixnDiscountInCart(cart) {
		if (!cart || !Array.isArray(cart.discount_codes)) return false;
		return cart.discount_codes.some(function(d) {
			if (!d || typeof d.code !== 'string') return false;
			if (d.applicable === false) return false;
			return d.code.indexOf(SPIXN_CODE_PREFIX) !== 0;
		});
	}

	// --- [S1-2657] 予約販売判定込みで SpinCard を描画するラッパ ---
	// fetchCartSnapshot 後の各描画経路から呼ぶ。pre-order 判定 (非同期) を解決してから
	// renderSpinCardForCart に hasPreOrder を渡す。判定 fetch 解決後に描画するため
	// 「一旦表示 → 消える」ちらつきは起きない。
	function renderSpinCardForCartGated(cart, subtotal, appliedStateOverride) {
		var seq = ++spinCardRenderSeq;
		return cartHasPreOrderProduct(cart).then(function(hasPreOrder) {
			// より新しい描画要求が来ていれば stale なのでスキップ（最新要求のみ反映）。
			if (seq !== spinCardRenderSeq) return;
			renderSpinCardForCart(cart, subtotal, appliedStateOverride, hasPreOrder);
		});
	}

	// --- [S1-2623] SpinCard 描画の単一エントリポイント ---
	// init / apply 成功後 / reset 完了後 / cart 操作 hook の 4 経路から呼ばれる。判定順:
	//   1. 他クーポン適用済 (`hasNonSpixnDiscountInCart`) → セクション非表示
	//      （`spixn_wari_*` attributes は触らない。他クーポン外せば次の render で復活）
	//   2. override が指定 → trust して「適用中」描画（apply 直後で cart attribute が遅延する
	//      ケース向け fallback）
	//   3. parseAppliedSpinCardState が state を返し、かつ SPIXN- code も cart にある
	//      → 「適用中」描画（happy path）
	//   4. それ以外 → 「未適用」SpinCard 描画 + subtotal で進捗反映
	// `hasNonSpixnDiscountInCart` は override より優先することで「他クーポンと共存」状態が
	// 万一発生してもセクション非表示を貫く（spec ポリシー）。
	function renderSpinCardForCart(cart, subtotal, appliedStateOverride, hasPreOrder) {
		removeExistingSpinCards();
		ensureSpinCardStylesInjected();
		spinCardEls = null;
		spinCardBalanceTextEl = null;
		var hasNonSpixn = hasNonSpixnDiscountInCart(cart);
		var hasSpixn = hasSpixnDiscountInCart(cart);
		// applied state を 1 度だけ算出して fingerprint と描画両方で使い回す。override が
		// 指定されているならそちらが優先（happy path / apply 成功直後の attribute 遅延 fallback）。
		var appliedState = appliedStateOverride || parseAppliedSpinCardState(cart);
		lastRenderedFingerprint = computeRenderFingerprint(hasNonSpixn, hasSpixn, appliedState, hasPreOrder);

		// [S1-2665] 予約販売(PRE-ORDER)商品がカートにあってもセクションは表示する。
		// 各 SpinCard ビルダーへ hasPreOrder を渡して、注記の追記と CTA の無効化を行う。
		// （旧 [S1-2657] の早期 return によるセクション全体の非表示は廃止。）

		if (hasNonSpixn) {
			lastAppliedState = null;
			// SpinCard 自体を出さないので balance iframe も不要。残置すると DOM / listener が leak する。
			teardownBalanceIframe();
			log('他クーポン適用済のため SpinCard を非表示');
			return;
		}

		// [T1-660] ここより後は必ず何らかの SpinCard を描画する（適用中(F)・C・A いずれも表示）。
		// 表示ファネルの分母として cart 単位で 1 回だけ spixncard/shown を送る。
		// renderSpinCardForCart を直接呼ぶ経路（fingerprint 変化時の再描画等）では
		// lastKnownCartToken が更新されないため、ここで引数 cart の token から同期して計測漏れを防ぐ。
		if (cart && cart.token) lastKnownCartToken = cart.token;
		sendSpixncardShownLog();

		if (appliedStateOverride) {
			lastAppliedState = appliedStateOverride;
			insertAppliedSpinCard(appliedStateOverride, hasPreOrder);
			// SpinCard_F でも live 残高を取得 (excludingDiscountId に適用 discount id を渡す)。
			// modal の edit-mode (excluding_discount_id 同じ値) と同じ集計結果になり、cart 側と
			// modal 側の「下取り可能残高」が乖離しなくなる。
			// [S1-2665] 予約販売商品がある場合は即割を利用できない (CTA 無効) ので、hidden iframe
			// の起動・postMessage・残高取得は不要。teardown して表示はスナップショット/「-」に留める。
			if (hasPreOrder) {
				teardownBalanceIframe();
			} else if (cachedLoginStatus === 'logged_in' && appliedStateOverride.discountId) {
				applyCachedBalanceIfFresh(appliedStateOverride.discountId);
				ensureBalanceIframe(appliedStateOverride.discountId);
			}
			return;
		}

		if (appliedState && hasSpixn) {
			lastAppliedState = appliedState;
			insertAppliedSpinCard(appliedState, hasPreOrder);
			// [S1-2665] 予約販売商品がある場合は残高 live 取得不要 (CTA 無効)。teardown する。
			if (hasPreOrder) {
				teardownBalanceIframe();
			} else if (cachedLoginStatus === 'logged_in' && appliedState.discountId) {
				applyCachedBalanceIfFresh(appliedState.discountId);
				ensureBalanceIframe(appliedState.discountId);
			}
			return;
		}

		// attributes だけ残って SPIXN- code が消えている孤児状態もここに落ちる
		// （hasSpixnDiscountInCart=false で適用中分岐を抜ける）。未適用 SpinCard を出すことで
		// ユーザに「割引適用されてません」と正しく伝える。
		lastAppliedState = null;
		// ログイン状態で分岐:
		//   logged_in   → SpinCard_C (アイテム未選択、残高欄あり、CTA「アイテムを確認」)
		//   それ以外     → SpinCard_A (注記入り、CTA「スピン即割を利用」)
		// cachedLoginStatus は init 時 oneTimeCodePromise 解決後に更新される。それまでは null
		// で SpinCard_A にフォールバックし、解決後に init 側で renderSpinCardForCart が再呼出される。
		if (cachedLoginStatus === 'logged_in') {
			// 直前まで SpinCard_F だった場合 cachedAvailableBalance は別 key 用の値なので使わない。
			// SpinCard_C 用 (excludingDiscountId なし = key '') の値だけ初期表示に使う。
			var initialBalance = (cachedAvailableBalanceForKey === '') ? cachedAvailableBalance : null;
			insertSpinCardLoggedInEmpty(initialBalance, hasPreOrder);
			// [S1-2665] 予約販売商品がある場合は残高 live 取得不要 (CTA 無効)。teardown して
			// 表示は初期スナップショット/「-」に留める。
			if (hasPreOrder) {
				teardownBalanceIframe();
			} else {
				ensureBalanceIframe(null);
			}
		} else {
			// SpinCard_A (未ログイン) は残高欄を持たない。balance iframe を残置する意味は無いので
			// 破棄してリソースを解放する。
			teardownBalanceIframe();
			insertSpinCard(hasPreOrder);
		}
		if (typeof subtotal === 'number') {
			updateSpinCardProgress(subtotal);
		}
	}

	// --- 描画 fingerprint を算出する ---
	// guard で「描画に影響する変化があったか」を確実に検知するためのキー文字列を返す。
	// boolean 2 つ + applied state の discountId / totalDiscount / items 件数を組み合わせる
	// ことで、別タブで SPIXN- 入れ替えが起きたケース（hasSpixn の boolean は不変だが
	// discountId / totalDiscount が変わる）も差分として検知できる。
	function computeRenderFingerprint(hasNonSpixn, hasSpixn, appliedState, hasPreOrder) {
		var discountId = appliedState && appliedState.discountId ? appliedState.discountId : '';
		var totalDiscount = appliedState && typeof appliedState.totalDiscount === 'number'
			? appliedState.totalDiscount
			: '';
		var itemsLen = appliedState && Array.isArray(appliedState.items)
			? appliedState.items.length
			: '';
		return [hasNonSpixn, hasSpixn, discountId, totalDiscount, itemsLen, !!hasPreOrder].join('|');
	}

	// --- S1-2581 用: ログインステータスだけ取り出す薄ラッパー ---
	// fetchOneTimeCode は構造体を返すが、cleanupIfSessionExpired 側は status だけ要るので分離する。
	function checkShopifyLoginStatus() {
		return fetchOneTimeCodeWithStatusSync().then(function(result) { return result.status; });
	}

	// --- セッション切れ検知 → cart 残骸の cleanup を実行する ---
	// 戻り値: cleanup を発動した (or 既に進行中) か (true/false)
	//   true  - cleanup の発動 or 進行中。呼び出し側は以降の cart 状態依存処理を skip するシグナル。
	//   false - status が 'no_customer' 以外、または cart に残骸が無い。caller は通常 flow へ。
	// onComplete は resetSpixnWariCartState 側の resetInProgress 早期 return 時には呼ばれないため、
	// onComplete に依存する caller はその前提で実装する。
	// options.loginStatus: 'logged_in' | 'no_customer' | 'unknown' を渡せば fetch をスキップ
	//   (init 時の oneTimeCodePromise 流用パス)。未指定なら新規 fetch。
	// options.onComplete: resetSpixnWariCartState の onComplete callback を passthrough
	// fail-secure: status が 'no_customer' (確定的未ログイン) のときのみ cleanup 発動。
	// 'logged_in' / 'unknown' は何もしない (= 既存表示維持)。
	// 同時実行抑止は resetSpixnWariCartState 内の resetInProgress フラグで gate されるため、
	// このヘルパー内では追加 gate を入れない。
	// 残骸 (SPIXN- discount or spixn_wari_* attributes) チェックは status fetch より先に
	// 行う: 残骸が無ければ session check 自体不要 (= /apps/spixn/api/customer_code への
	// 不要な GET = backend の DB code rotation を避ける)。
	function cleanupIfSessionExpired(cart, options) {
		// residue 判定は applicable を問わない (invalid SPIXN- も掃除対象)。
		// hasSpixnCodeInCart / hasSpixnWariAttributes 共に prefix / 属性キーの存在のみで判定。
		var hasResidue = hasSpixnCodeInCart(cart) || hasSpixnWariAttributes(cart);
		if (!hasResidue) return Promise.resolve(false);

		var statusPromise = options && options.loginStatus
			? Promise.resolve(options.loginStatus)
			: checkShopifyLoginStatus();

		return statusPromise.then(function(status) {
			if (status !== 'no_customer') return false;

			log('セッション切れを検知。spixn-wari 残骸を cleanup します');
			var onComplete = options && options.onComplete;
			resetSpixnWariCartState(cart, /*cartIsFresh=*/true, onComplete);
			return true;
		});
	}

	// --- spixn-wari の状態（discount コード + attribute）をカートからクリアする ---
	// 用途は 2 通り:
	//   (a) カート構成変更（item_count 減少）の検知時リセット（installCartFetchHook から）
	//   (b) checkout submit 時の閾値割れ block 時リセット（handleCheckoutSubmit から）
	// 応答失敗時は呼び出し側で先に描画済みのカード（applied なら SpinCard_F、orphan なら
	// 未適用 SpinCard）をそのまま維持する（次回 init で再試行されるため永続的な異常状態には
	// ならない）。
	// `discount: ''` はカート全 cart-level discount を消すため、SPIXN- 系コードが
	// 残っているケース限定で送る。それ以外（ユーザが手動で別クーポンに差し替えた等）は
	// attribute だけクリアして既存の discount を温存する。
	// 呼び出し元が直前に取得した cart をそのまま渡してくる場合は `cartIsFresh=true` を
	// 指定して /cart.js の再取得を省略できる。
	function resetSpixnWariCartState(cart, cartIsFresh, onComplete) {
		if (resetInProgress) {
			log('reset 進行中のため追加 reset をスキップ');
			return;
		}
		resetInProgress = true;
		var freshCartPromise = cartIsFresh ? Promise.resolve(cart) : fetchCartSnapshot();
		// 全段を return でつないで、outer .then 内の同期例外も含めて
		// .catch（POST 失敗時） / .then（finally 役: flag 解除）に確実に到達させる。
		freshCartPromise.then(function(freshCart) {
			var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
			var sectionPlan = buildCartSectionPlan();
			var url = routesRoot + 'cart/update.js?sections=' + sectionPlan.requestIds.join(',');
			// 送信判定は applicable を問わない (invalid SPIXN- も `discount: ''` で剥がす対象)。
			var hasSpixnCode = hasSpixnCodeInCart(freshCart || cart);
			var body = {
				attributes: {
					spixn_wari_discount_id: '',
					spixn_wari_selected_items: '',
					spixn_wari_total_discount: '',
					spixn_wari_available_balance: '',
				},
			};
			if (hasSpixnCode) body.discount = '';
			var fallbackCart = freshCart || cart;
			return fetch(url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(body),
			}).then(function(res) {
				if (!res.ok) throw new Error('cart/update.js returned ' + res.status);
				return res.json();
			}).then(function(updatedCart) {
				log('spixn-wari の状態をリセットしました', {
					discount_codes: updatedCart && updatedCart.discount_codes,
					cleared_discount: hasSpixnCode,
				});
				if (updatedCart && updatedCart.sections) {
					applyCartSections(updatedCart.sections, sectionPlan.swap);
				}
				// updatedCart の subtotal が取れない極端なケースは元/再取得 cart の値で fallback する
				var newSubtotal = parseCartSubtotal(updatedCart);
				if (typeof newSubtotal !== 'number') newSubtotal = parseCartSubtotal(fallbackCart);
				if (typeof newSubtotal === 'number') lastKnownSubtotal = newSubtotal;
				if (updatedCart && updatedCart.token) lastKnownCartToken = updatedCart.token;
				// item_count も最新化して、直後の hook 発火で再リセットがループしないようにする
				if (updatedCart && typeof updatedCart.item_count === 'number') {
					lastKnownItemCount = updatedCart.item_count;
				}
				// [S1-2623] renderSpinCardForCart で再描画。reset 直後に他クーポンだけ残っている
				// ケース（SPIXN- 剥がし + 他クーポン残存）なら非表示分岐に落ちる。
				// updatedCart が無い／subtotal が取れない場合は fallbackCart を渡す。
				renderSpinCardForCartGated(updatedCart || fallbackCart, newSubtotal);
				if (typeof onComplete === 'function') {
					try { onComplete(true); } catch (e) { /* ignore */ }
				}
			});
		}).catch(function(err) {
			// POST 失敗時 / outer .then 内の同期例外時は呼び出し側で先に描画済みのカード
			// （applied なら SpinCard_F、orphan なら未適用 SpinCard）をそのまま残す
			log('spixn-wari 状態のリセットに失敗', { error: err && err.message });
			if (typeof onComplete === 'function') {
				try { onComplete(false); } catch (e) { /* ignore */ }
			}
		}).then(function() {
			// success/error/同期例外いずれの後でも flag を解除する。Promise.finally と等価だが
			// 古い実装ブラウザでも動くように then を使う。
			resetInProgress = false;
		});
	}

	// --- /cart ページの checkout 送信を監視する ---
	// /cart ページでのみ form#cart / form[action="/cart"] が存在する。商品ページ等では no-op。
	// 旧カート画面など form 要素が複数あるテーマや form#cart のみのテーマ (Dawn 系) でも
	// guard を漏れなく適用するため、両方の selector を querySelectorAll でまとめて拾う。
	// capture phase で先に listener が走るようにし、submit を必要に応じて preventDefault する。
	function installCheckoutSubmitGuard() {
		var forms = document.querySelectorAll('form#cart, form[action="/cart"]');
		if (forms.length === 0) return;
		Array.prototype.forEach.call(forms, function(form) {
			form.addEventListener('submit', handleCheckoutSubmit, true);
		});
	}

	// --- checkout 画面へ遷移する ---
	// form.submit() は event.submitter（name="checkout"）を含まずフォームを送信するため、
	// Shopify がカート更新リクエストとして解釈しカートページがリロードされてしまう。
	// Shopify の多言語/サブパス構成（例: /en/）に対応するため routes.root を経由する。
	function navigateToCheckout() {
		var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		// root が "/" の場合は "/checkout"、"/en/" の場合は "/en/checkout" になる。
		window.location.href = root + 'checkout';
	}

	// --- checkout 送信時の閾値割れ検証 ---
	// fresh な cart を取得し、cart に SPIXN- discount があり、かつ
	// cart_subtotal < max(SPIXN_MIN_SUBTOTAL, total_discount_amount) なら
	// submit を block して discount/attribute をクリアし、ユーザに再クリックを促す。
	// 閾値以上 / SPIXN- 未適用 / cart 取得失敗 (= 判定不能) なら通常 submit を許可する。
	function handleCheckoutSubmit(event) {
		// 旧カート画面など、同じ form 内に「更新」(name="update") 等 checkout 以外の
		// submitter が存在するテーマでは、guard を適用すると update 操作まで /checkout に
		// 飛んでしまう。event.submitter の name を見て、明示的に checkout 以外と判別できる
		// 場合は guard を素通りさせて通常 submit に任せる。
		// submitter が null (programmatic submit / 一部ブラウザ) の場合は安全側に倒し
		// guard を適用する (SPIXN- 適用中の誤遷移を防ぐため)。
		var submitter = event.submitter;
		if (submitter && submitter.name && submitter.name !== 'checkout') {
			return;
		}
		// 同期で preventDefault する。fetchCartSnapshot の結果を待ってから判定するが、
		// microtask 内で preventDefault を呼んでもブラウザによっては既に navigation が
		// 始まっており効かないため、まず submit を止めてから判定 → 通すなら navigateToCheckout()
		// で navigation を再開する戦略を取る。
		// form.submit() は使わない（name="checkout" が欠落してカートがリロードされるため）。
		event.preventDefault();
		fetchCartSnapshot().then(function(cart) {
			if (!cart) {
				// 判定不能。誤 block 回避のため通す。
				navigateToCheckout();
				return;
			}
			if (!hasSpixnDiscountInCart(cart)) {
				// SPIXN- discount 無し。そのまま通す。
				navigateToCheckout();
				return;
			}

			// [S1-2581] checkout submit 時の session check (閾値検証より先に行う)。
			// no_customer 確定なら block + reset + alert で離脱、ユーザに再ログイン → 再クリックを促す。
			// logged_in / unknown は通常 flow へ抜ける (unknown は誤 block 回避で通す)。
			return checkShopifyLoginStatus().then(function(status) {
				if (status === 'no_customer') {
					log('checkout submit 時にセッション切れを検知、block + reset を発動');
					// resetSpixnWariCartState は resetInProgress=true の場合 onComplete を
					// 呼ばずに早期 return する。その状態だと alert が表示されずユーザが
					// block 理由を認識できないため、進行中なら即 alert を出して block 維持。
					if (resetInProgress) {
						alert(SPIXN_WARI_SESSION_EXPIRED_ALERT_MESSAGE);
						return;
					}
					resetSpixnWariCartState(cart, /*cartIsFresh=*/true, function(success) {
						alert(success
							? SPIXN_WARI_SESSION_EXPIRED_ALERT_MESSAGE
							: SPIXN_WARI_BLOCK_ERROR_ALERT_MESSAGE);
					});
					return;  // navigateToCheckout() を呼ばない (block 維持)
				}

				// [S1-2586] 既存の閾値検証ロジック
				var subtotal = parseCartSubtotal(cart);
				if (typeof subtotal !== 'number') {
					// subtotal 取得失敗 = 判定不能。誤 block 回避のため通す。
					navigateToCheckout();
					return;
				}
				var totalDiscount = Number(cart.attributes && cart.attributes.spixn_wari_total_discount);
				if (!isFinite(totalDiscount) || totalDiscount < 0) totalDiscount = 0;
				var threshold = Math.max(SPIXN_MIN_SUBTOTAL, totalDiscount);
				if (subtotal >= threshold) {
					// 閾値以上、そのまま通す。
					navigateToCheckout();
					return;
				}
				log('checkout submit 時に閾値割れを検出、block + reset を発動', {
					subtotal: subtotal,
					threshold: threshold,
				});
				// ここで navigateToCheckout() を呼ばない（block 維持）。
				// reset 完了後にユーザが再度 checkout button をクリックすれば次回は通過する。
				resetSpixnWariCartStateThenAlert(cart);
			});
		}).catch(function(err) {
			// fetch / 判定で例外時は通す（誤 block 回避）。
			log('checkout submit 時の判定に失敗、checkout へ直接遷移して通す', { error: err && err.message });
			navigateToCheckout();
		});
	}

	// reset 完了 (/cart/update 成功) 時に成功 alert、失敗時にエラー alert を出す薄いラッパー。
	// resetSpixnWariCartState は内部で fetch を投げるため、その完了/失敗を観測するために
	// callback API を渡せるよう改変するか、ここでは alert 表示だけを切り出した版を再実装する。
	// （resetSpixnWariCartState のシグネチャを大きく変えないため、別ラッパー側で対応する。）
	function resetSpixnWariCartStateThenAlert(cart) {
		// resetSpixnWariCartState は Promise を返さない既存設計のため、簡易的に
		// 「reset 開始 → setTimeout 0 で待ってから alert」の楽観表示を取る…ではなく、
		// 完了通知を取る正攻法として resetSpixnWariCartState 側に optional callback を生やす。
		// 既存呼び出しに影響を与えないよう、第 3 引数 callback (success: bool) を追加する。
		resetSpixnWariCartState(cart, /*cartIsFresh=*/true, function(success) {
			if (success) {
				alert(SPIXN_WARI_BLOCK_ALERT_MESSAGE);
			} else {
				alert(SPIXN_WARI_BLOCK_ERROR_ALERT_MESSAGE);
			}
		});
	}

	// --- 初期化 ---
	// /cart.js を 1 回だけ叩き、subtotal と適用済みステートを同じレスポンスから取り出す。
	function init() {
		log('初期化します', { spShopId: spShopId, iframeBaseUrl: iframeBaseUrl });
		// App Proxy フロー: one_time_code を iframe ロードと並列に取りに行き、
		// SPIXN_WARI_READY 受信後に postMessage で iframe へ渡す。
		// 失敗時 (未ログイン等) は null を返し SPIXN_WARI_NO_CUSTOMER でログイン誘導 UI に遷移する。
		oneTimeCodePromise = fetchOneTimeCode();
		oneTimeCodePromise.then(function(result) {
			// code 自体をログ出力すると外部から取得可能になりセキュリティリスクなので、
			// 取得有無 + status のみ debug ログ。
			log('one_time_code:', result.code === null ? '(none)' : '(received)', 'status:', result.status);
		});
		// fetch ラップは描画するカード種別に依存しないので先に仕掛ける
		installCartFetchHook();
		// /cart ページなら checkout button (form submit) の閾値割れ検証を仕掛ける。
		// /cart 以外のページ（商品ページ等）では form が存在しないので no-op。
		// fetchCartSnapshot の結果に依存しないため、.then の中ではなくここで仕掛ける
		// （cart fetch が失敗しても guard は動作させたい）。
		installCheckoutSubmitGuard();
		fetchCartSnapshot().then(function(cart) {
			var subtotal = parseCartSubtotal(cart);
			lastKnownSubtotal = subtotal;
			lastKnownCartToken = (cart && cart.token) ? cart.token : null;
			// fetch hook の item_count 比較の基準点を記録。
			// cross-session 変更（タブを閉じてる間に別画面で qty 変更等）はこの初期スナップショットで
			// 一旦受け入れる形になる（hook 経由でしか検知しないため）。
			lastKnownItemCount = (cart && typeof cart.item_count === 'number') ? cart.item_count : null;
			// [S1-2623] 描画は renderSpinCardForCart に一元化。
			// 他クーポン適用済 → 非表示 / attrs + SPIXN- 両方 → 適用中 / それ以外 → 未適用。
			renderSpinCardForCartGated(cart, subtotal);

			// [S1-2581] PR #1487 が走らせた oneTimeCodePromise の結果を流用して session check。
			// 残骸 (SPIXN- discount or spixn_wari_* attributes) があり no_customer 確定なら silent reset。
			// fetchOneTimeCode は内部で resolve('unknown') する設計のため .catch は不要だが、
			// 万一の breakage 時に init を巻き込まないよう defensive に .catch を付ける。
			oneTimeCodePromise.then(function(result) {
				cachedLoginStatus = result.status;
				cleanupIfSessionExpired(cart, { loginStatus: result.status });
				// [S1-2640] ログイン状態判明後の SpinCard_C 再描画。
				// 初回 render は OTC 未解決のため SpinCard_A で出ているケースがあるので、
				// logged_in 確定 + 未適用なら一度だけ再 render して SpinCard_C に切り替える。
				// 適用済 (lastAppliedState) や他クーポン適用済 (hasNonSpixnDiscountInCart) のときは
				// 当該分岐内で return されるため副作用なし。
				if (result.status === 'logged_in' && !lastAppliedState) {
					renderSpinCardForCartGated(cart, lastKnownSubtotal);
				}
			}).catch(function(err) {
				log('init session check で例外 (cleanup スキップ)', { error: err && err.message });
			});
		});
	}

	// --- 公開 API ---
	// SpixnWari.initialize(shopId, options)
	// options: { iframeBaseUrl, stripePublishableKey?, debug? }
	// このファイルは App Proxy 必須版 (常に App Proxy 経由で one_time_code を取得する)。
	// authWithAppProxy オプションは廃止。Cognito 認証フロー版は spixn_wari_legacy.js を使用する。
	window.SpixnWari = {
		initialize: function(shopId, options) {
			spShopId = shopId;
			if (options && options.iframeBaseUrl) {
				try {
					iframeBaseUrl = new URL(options.iframeBaseUrl).origin;
				} catch (e) {
					console.error('[SpixnWari] iframeBaseUrl が無効です', options.iframeBaseUrl);
					return;
				}
			}
			if (!iframeBaseUrl) {
				console.error('[SpixnWari] iframeBaseUrl が未指定です。options.iframeBaseUrl を設定してください。');
				return;
			}
			if (options && typeof options.stripePublishableKey === 'string') {
				stripePublishableKey = options.stripePublishableKey;
			}
			if (options && typeof options.debug === 'boolean') {
				DEBUG_MODE = options.debug;
			}
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', init);
			} else {
				init();
			}
		},
	};
})();
